import { FC } from 'react';

export const MinusCircle = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5Z"
        stroke="#767676"
      />
      <path
        d="M9.625 14H18.375"
        stroke="#767676"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const QuantityMinus = ({ onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5Z"
        stroke="#198000"
      />
      <path
        d="M9.625 14H18.375"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const QuantityPlus = ({ onClick }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5Z"
        stroke="#198000"
      />
      <path
        d="M9.625 14H18.375"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.625V18.375"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const QuantityCaretUp = ({ onClick }) => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M2.98119 1.44658C3.36876 0.794405 4.31294 0.794407 4.70051 1.44658L6.95431 5.23913C7.35044 5.90572 6.87006 6.75 6.09465 6.75H1.58706C0.81165 6.75 0.331267 5.90572 0.727399 5.23913L2.98119 1.44658Z"
        fill="#198000"
      />
    </svg>
  );
};
export const QuantityCaretDown = ({ onClick }) => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M4.70045 5.55342C4.31288 6.20559 3.3687 6.20559 2.98113 5.55342L0.727335 1.76087C0.331202 1.09428 0.811585 0.25 1.58699 0.25L6.09458 0.249999C6.86999 0.249999 7.35037 1.09428 6.95424 1.76087L4.70045 5.55342Z"
        fill="#198000"
      />
    </svg>
  );
};

export const PlusCircle = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5Z"
        stroke="#767676"
      />
      <path
        d="M9.625 14H18.375"
        stroke="#767676"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.625V18.375"
        stroke="#767676"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ProhibitIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 45C35.1503 45 45 35.1503 45 23C45 10.8497 35.1503 1 23 1C10.8497 1 1 10.8497 1 23C1 35.1503 10.8497 45 23 45Z"
        stroke="#198000"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M7.44531 7.44531L38.558 38.558"
        stroke="#198000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Apple = () => {
  return (
    <svg
      width="28"
      height="33"
      viewBox="0 0 28 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.0348 25.1825C26.5536 26.2941 25.9841 27.3174 25.3241 28.2582C24.4246 29.5407 23.6881 30.4284 23.1205 30.9214C22.2406 31.7306 21.2979 32.145 20.2884 32.1685C19.5637 32.1685 18.6897 31.9623 17.6723 31.544C16.6516 31.1276 15.7136 30.9214 14.8559 30.9214C13.9564 30.9214 12.9916 31.1276 11.9597 31.544C10.9263 31.9623 10.0937 32.1803 9.45716 32.2019C8.48909 32.2432 7.52417 31.817 6.56101 30.9214C5.94627 30.3852 5.17735 29.466 4.25622 28.1639C3.26792 26.7734 2.45541 25.1609 1.81886 23.3226C1.13715 21.3369 0.79541 19.4142 0.79541 17.5527C0.79541 15.4203 1.25617 13.5812 2.17907 12.04C2.90438 10.8021 3.86931 9.82559 5.07699 9.10872C6.28467 8.39185 7.58957 8.02654 8.99483 8.00317C9.76375 8.00317 10.7721 8.24101 12.0251 8.70845C13.2746 9.17746 14.0769 9.4153 14.4287 9.4153C14.6917 9.4153 15.583 9.13719 17.0939 8.58275C18.5227 8.06857 19.7286 7.85567 20.7165 7.93953C23.3935 8.15557 25.4047 9.21085 26.7422 11.112C24.348 12.5627 23.1637 14.5944 23.1873 17.2009C23.2089 19.2311 23.9454 20.9206 25.3929 22.262C26.0489 22.8846 26.7815 23.3658 27.5965 23.7075C27.4198 24.2201 27.2332 24.7111 27.0348 25.1825ZM20.8953 1.02302C20.8953 2.61429 20.3139 4.10006 19.1551 5.47527C17.7567 7.11012 16.0653 8.05482 14.2311 7.90575C14.2078 7.71485 14.1942 7.51393 14.1942 7.30279C14.1942 5.77518 14.8592 4.14032 16.0402 2.8036C16.6298 2.1268 17.3797 1.56405 18.289 1.11513C19.1964 0.672911 20.0547 0.428354 20.8619 0.386475C20.8854 0.599203 20.8953 0.811945 20.8953 1.023V1.02302Z"
        fill="black"
      />
    </svg>
  );
};
export const WhiteApple = ({ className }) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9825 0.587585C10.9854 0.39139 10.9765 0.195198 10.9559 0C8.62088 0.465077 7.41426 1.9624 7.35561 4.27719C7.35774 4.27822 7.35997 4.2797 7.36223 4.28119C7.36658 4.28407 7.37104 4.28702 7.37516 4.28702L7.38046 4.28664C7.79077 4.25728 8.19793 4.22815 8.58725 4.07755C9.04237 3.90286 9.41226 3.60567 9.74617 3.26688C10.4774 2.54619 10.9162 1.59522 10.9825 0.587585ZM14.4305 5.87019C14.4801 5.82648 14.5296 5.78277 14.5791 5.73896C14.5726 5.72748 14.565 5.7166 14.5564 5.70644L14.5561 5.70608C14.478 5.61697 14.3999 5.52785 14.3218 5.44025C13.6845 4.73848 12.9228 4.23786 11.9594 4.05788C11.2267 3.92598 10.4717 3.9696 9.76044 4.18492C9.53067 4.25072 9.30143 4.32062 9.07179 4.39064C8.81844 4.46789 8.56461 4.54528 8.30905 4.61748C7.96925 4.72675 7.60505 4.74427 7.2557 4.66815C7.17086 4.64731 7.08575 4.62753 7.00068 4.60776C6.8356 4.56939 6.67067 4.53105 6.50811 4.48514C6.47499 4.47582 6.44188 4.46648 6.40876 4.45714C5.85077 4.29973 5.29269 4.14229 4.70952 4.08661C3.46927 3.96713 2.40966 4.32936 1.54946 5.2096C0.722108 6.0596 0.282625 7.08806 0.105894 8.22768C-0.0906698 9.50645 -0.00241928 10.8111 0.364735 12.0542C0.773879 13.4551 1.42852 14.7778 2.30018 15.9646C2.63471 16.45 3.05885 16.8717 3.55138 17.2086C4.05186 17.5368 4.59926 17.7168 5.20374 17.5769C5.58713 17.4793 5.96419 17.3599 6.33294 17.2192C6.8256 17.0452 7.31201 16.8917 7.8422 16.9038C8.26556 16.9231 8.68407 16.9994 9.08558 17.1307C9.23588 17.1754 9.38573 17.2213 9.53555 17.2672C9.7786 17.3417 10.0216 17.4161 10.2664 17.4854C11.0601 17.7122 11.7639 17.5232 12.3895 17.0316C12.5763 16.8888 12.7518 16.7326 12.9142 16.5643C13.7737 15.6538 14.4032 14.6042 14.8872 13.4698C14.9417 13.3428 14.9892 13.2135 15.0374 13.0825C15.0631 13.0124 15.0891 12.9418 15.1163 12.8709C15.0825 12.8583 15.051 12.8469 15.021 12.836C14.9754 12.8194 14.9331 12.8041 14.8911 12.7877C14.2968 12.5518 13.8503 12.1442 13.4757 11.6534C13.1122 11.1936 12.8557 10.6633 12.7239 10.0988C12.592 9.53432 12.5879 8.94892 12.7117 8.38271C12.8837 7.52062 13.3717 6.82943 14.0216 6.23504C14.1565 6.11178 14.2935 5.99096 14.4305 5.87019Z"
        fill="white"
      />
    </svg>
  );
};
export const Star = ({ className, onClick }) => {
  return (
    <svg
      width="40"
      height="37"
      viewBox="0 0 40 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M20 0L24.4903 13.8197H39.0211L27.2654 22.3607L31.7557 36.1803L20 27.6393L8.2443 36.1803L12.7346 22.3607L0.97887 13.8197H15.5097L20 0Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};
export const ArrowRight = ({ className }: { className?: any }) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.186 6.19403C11.7783 6.59 11.7783 7.46079 11.186 7.85675L2.32542 13.7797C1.66094 14.2238 0.769686 13.7476 0.769686 12.9483L0.769686 1.10246C0.769687 0.303206 1.66095 -0.173068 2.32542 0.271104L11.186 6.19403Z"
        fill="#198000"
      />
    </svg>
  );
};
export const ArrowDown = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.625 1.28906L7 6.91406L1.375 1.28906"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Bag = () => {
  return (
    <svg
      width="48"
      height="46"
      viewBox="0 0 48 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.625 10.875H3.375C2.33947 10.875 1.5 11.7145 1.5 12.75V42.75C1.5 43.7855 2.33947 44.625 3.375 44.625H44.625C45.6605 44.625 46.5 43.7855 46.5 42.75V12.75C46.5 11.7145 45.6605 10.875 44.625 10.875Z"
        stroke="#3D3935"
        strokeWidth="1.55882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.625 18.375V10.875C14.625 8.3886 15.6127 6.00403 17.3709 4.24587C19.129 2.48772 21.5136 1.5 24 1.5C26.4864 1.5 28.871 2.48772 30.6291 4.24587C32.3873 6.00403 33.375 8.3886 33.375 10.875V18.375"
        stroke="#3D3935"
        strokeWidth="1.55882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BtnArrowUp: FC<any> = ({ className }) => {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.28926 0.718108C8.6806 0.322712 9.3194 0.322711 9.71074 0.718108L17.7063 8.79655C18.3313 9.42799 17.884 10.5 16.9956 10.5H1.00442C0.115997 10.5 -0.331286 9.42799 0.293676 8.79655L8.28926 0.718108Z"
        fill="#198000"
      />
    </svg>
  );
};
export const CaretDown = () => {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7856 5.625L9.25802 10.3125L3.73047 5.625"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Close = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 7L7 17"
        stroke="#198000"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 7L17 17"
        stroke="#198000"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const CZLogo: FC<any> = ({ className }) => {
  return (
    <svg
      width="170"
      height="56"
      viewBox="0 0 170 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_23010_154541)">
        <path
          d="M19.345 50.4655H11.5082L31.6007 25.2238V20.2076H0.994681V33.3438H5.60035C5.96206 26.8264 8.05993 24.8604 14.1305 24.8604H19.8876L0 50.1557V54.9157H33.156V40.7966H27.9716C27.6582 47.9336 25.7773 50.4655 19.345 50.4655Z"
          fill="#3D3935"
        />
        <path
          d="M92.7044 39.7123C97.4126 39.7123 100.758 39.2953 103.218 37.3294C105.364 35.6255 106.57 33.1413 106.57 30.1923C106.57 23.1089 102.127 20.2076 92.7044 20.2076H72.0211H71.0505H56.3835V24.6042C56.8537 24.5506 57.3239 24.5506 57.7459 24.5506C61.1459 24.5506 61.4594 25.7898 61.4594 29.9302V43.9957C61.4594 48.8034 59.5243 50.823 54.2374 50.823C49.686 50.823 48.2211 48.5472 48.2211 43.5787V29.674C48.2211 25.7957 48.3236 24.5566 51.7778 24.5566C52.3023 24.5566 52.875 24.5566 53.5562 24.6102V20.2136H33.6807V25.1404C34.3136 25.1404 34.7778 25.1345 35.1998 25.1345C38.0814 25.1345 38.5456 26.5821 38.5456 30.4068V45.086C38.5456 51.9668 43.6214 56 52.459 56C62.1406 56 67.1562 52.0204 67.1562 44.6749V29.9838C67.1562 27.4519 67.2165 26.04 67.5722 25.5276C68.1147 24.7591 69.3867 24.7234 71.5087 24.7234L72.9796 24.7591C75.8551 24.7591 76.1746 25.2238 76.1746 27.7617V47.3617C76.1746 49.8936 75.8612 50.3583 72.9796 50.3583H71.0445V54.9098H91.758V50.3583H89.2441C86.3626 50.3583 86.0009 49.8936 86.0009 47.3617V39.7123H92.7044ZM86.0069 24.7591H89.2502C94.0608 24.7591 96.2612 26.1055 96.2612 29.7753C96.2612 33.9098 94.2175 35.2085 89.2502 35.2085H86.0069V24.7591Z"
          fill="#3D3935"
        />
        <path
          d="M158.389 33.3498C151.167 31.5923 147.297 31.6936 147.297 28.3336C147.297 25.9566 149.341 24.3004 153 24.3004C158.805 24.3004 162.73 27.3506 163.357 32.5217H168.173V19.8502H163.833L162.784 22.2808C160.119 20.2613 156.611 19.3855 152.216 19.3855C143.065 19.3855 137.935 23.5259 137.935 30.4545C137.935 33.5583 139.189 36.0902 141.492 37.9013C144.054 39.9208 147.767 40.7966 152.584 41.9345C157.346 43.0723 160.427 43.3285 160.427 46.7481C160.427 49.2323 158.124 50.8885 154.097 50.8885C148.394 50.8885 144.054 47.3736 143.216 41.7319H138.508V50.3702H136.958C134.758 50.3702 134.131 49.5421 133.347 47.1651L124.715 20.2196H114.256L105.249 47.0042C104.411 49.4349 103.995 50.3642 101.168 50.3642H99.9141V54.9157H115.292V50.3642H113.568C111.531 50.3642 110.747 50.2094 110.747 49.1251C110.747 48.8689 110.801 48.3506 111.006 47.7311L112.314 43.7515H122.412L123.768 48.0468C123.871 48.4579 124.028 48.8213 124.028 49.1311C124.028 50.1617 123.135 50.3702 120.833 50.3702H119.368V54.9217H138.496V54.9574H142.734L144.144 52.8485C146.706 54.6596 150.998 55.9523 155.441 55.9523C164.544 55.9523 169.988 51.4545 169.988 44.6749C170 38.6757 166.232 35.2621 158.389 33.3498ZM113.828 39.2477L117.439 28.28L120.941 39.2477H113.828Z"
          fill="#3D3935"
        />
        <path
          d="M115.371 8.06638C115.371 12.5226 111.796 16.1328 107.389 16.1328H62.6224C58.2096 16.1328 54.6348 12.5226 54.6348 8.06638C54.6287 3.61021 58.2096 0 62.6224 0H107.389C111.796 0 115.371 3.61021 115.371 8.06638ZM73.0032 6.97617C72.6355 3.91404 69.8805 3.36596 67.7103 3.36596C64.4369 3.36596 62.3933 4.76 62.3933 8.06042C62.3933 11.3608 64.4369 12.7549 67.7103 12.7549C70.5738 12.7549 72.7259 11.6826 73.0273 9.09106H70.3688C70.1277 10.497 68.9823 11.057 67.7947 11.057C65.4798 11.057 64.9855 9.26383 64.9855 8.05447C64.9855 6.84511 65.4798 5.05191 67.7947 5.05191C69.0667 5.05191 70.1397 5.68936 70.3688 6.97021H73.0032V6.97617ZM82.6607 12.5106H85.2951L81.3344 3.61617H78.3866L74.4319 12.5106H77.0663L77.7958 10.6817H81.9312L82.6607 12.5106ZM81.2741 9.06128H78.4468L79.8575 5.53447L81.2741 9.06128ZM87.4713 12.5106H89.9128V8.94808H95.1575V7.25021H89.9128V5.30808H95.5132V3.61617H87.4713V12.5106ZM97.8401 12.5106H106.292V10.8187H100.282V8.77532H105.942V7.14894H100.282V5.30808H106.244V3.61617H97.8401V12.5106ZM100.794 2.85957H102.807L104.622 1.09021H101.909L100.794 2.85957Z"
          fill="#3D3935"
        />
      </g>
      <defs>
        <clipPath id="clip0_23010_154541">
          <rect width="170" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LocationIcon = () => {
  return (
    <svg
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="44.5" cy="44" r="44" fill="#198000" />
      <g clipPath="url(#clip0_22929_157019)">
        <path
          d="M44.5 48C47.8137 48 50.5 45.3137 50.5 42C50.5 38.6863 47.8137 36 44.5 36C41.1863 36 38.5 38.6863 38.5 42C38.5 45.3137 41.1863 48 44.5 48Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.814 53.3144L47.328 61.8004C46.578 62.5497 45.5612 62.9705 44.501 62.9705C43.4408 62.9705 42.424 62.5497 41.674 61.8004L33.186 53.3144C30.9484 51.0767 29.4247 48.2258 28.8074 45.1221C28.1901 42.0184 28.507 38.8014 29.718 35.8779C30.929 32.9543 32.9798 30.4555 35.611 28.6974C38.2421 26.9393 41.3355 26.001 44.5 26.001C47.6645 26.001 50.7579 26.9393 53.389 28.6974C56.0202 30.4555 58.071 32.9543 59.282 35.8779C60.493 38.8014 60.8099 42.0184 60.1926 45.1221C59.5753 48.2258 58.0516 51.0767 55.814 53.3144Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22929_157019">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(20.5 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FacebookLogo = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.0856C28 6.30631 21.732 0 14 0C6.26801 0 0 6.30631 0 14.0856C0 21.1161 5.1196 26.9433 11.8125 28V18.1572H8.25781V14.0856H11.8125V10.9823C11.8125 7.45214 13.9026 5.50217 17.1005 5.50217C18.6322 5.50217 20.2344 5.77728 20.2344 5.77728V9.24365H18.469C16.7299 9.24365 16.1875 10.3294 16.1875 11.4433V14.0856H20.0703L19.4496 18.1572H16.1875V28C22.8804 26.9433 28 21.1161 28 14.0856Z"
        fill="#1877F2"
      />
    </svg>
  );
};
export const GoogleLogo = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.44 14.3182C27.44 13.3255 27.3509 12.371 27.1855 11.4546H14V16.87H21.5345C21.21 18.62 20.2236 20.1028 18.7409 21.0955V24.6082H23.2655C25.9127 22.171 27.44 18.5819 27.44 14.3182Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9997 27.9997C17.7797 27.9997 20.9488 26.746 23.2651 24.6078L18.7406 21.0951C17.487 21.9351 15.8833 22.4315 13.9997 22.4315C10.3533 22.4315 7.26695 19.9688 6.16604 16.6597H1.48877V20.2869C3.79241 24.8624 8.52695 27.9997 13.9997 27.9997Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16636 16.6602C5.88636 15.8202 5.72727 14.9229 5.72727 14.0002C5.72727 13.0774 5.88636 12.1802 6.16636 11.3402V7.71289H1.48909C0.540909 9.60289 0 11.7411 0 14.0002C0 16.2593 0.540909 18.3974 1.48909 20.2874L6.16636 16.6602Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9997 5.56818C16.0551 5.56818 17.9006 6.27455 19.3515 7.66182L23.367 3.64636C20.9424 1.38727 17.7733 0 13.9997 0C8.52695 0 3.79241 3.13727 1.48877 7.71273L6.16604 11.34C7.26695 8.03091 10.3533 5.56818 13.9997 5.56818Z"
        fill="#EA4335"
      />
    </svg>
  );
};
export const FilledHouseIcon = () => {
  return (
    <svg
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="44.5" cy="44" r="44" fill="#198000" />
      <g clipPath="url(#clip0_22929_157280)">
        <path
          d="M26.5 62H62.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.5 62V34L46.5 26V62"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.5 62V42L46.5 34"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.5 38V38.02"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.5 44V44.02"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.5 50V50.02"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.5 56V56.02"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22929_157280">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(20.5 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CalenderIcon: FC<any> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17 4H21C21.2652 4 21.5196 4.10536 21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H7V2H9V4H15V2H17V4ZM20 12H4V20H20V12ZM15 6H9V8H7V6H4V10H20V6H17V8H15V6ZM6 14H8V16H6V14ZM11 14H13V16H11V14ZM16 14H18V16H16V14Z"
        fill="#198000"
      />
    </svg>
  );
};
export const Keto = () => {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.725 10.5124L4.99375 11.3188V12.9125H4.14531V7.57804H4.99375V10.1984L7.3375 7.57804H8.38281L6.24531 9.92179L8.58906 12.9031H7.60468L5.725 10.5124Z"
        fill="#DF854F"
      />
      <path
        d="M12.5547 12.1344V12.9125H9.27343V7.57804H12.4891V8.35624H10.1219V9.84683H11.9406V10.611H10.1219V12.1344H12.5547Z"
        fill="#DF854F"
      />
      <path
        d="M16.9 8.35624H15.4938V12.9125H14.6453V8.35624H13.2391V7.57804H16.9V8.35624Z"
        fill="#DF854F"
      />
      <path
        d="M22.7219 10.2454C22.7265 10.7942 22.568 11.3321 22.2664 11.7908C21.9648 12.2494 21.5338 12.6081 21.028 12.8214C20.5223 13.0347 19.9645 13.0929 19.4256 12.9886C18.8867 12.8844 18.3909 12.6224 18.0011 12.2359C17.6113 11.8495 17.3451 11.3559 17.2363 10.8179C17.1275 10.2799 17.181 9.72171 17.39 9.21413C17.5989 8.70656 17.954 8.27241 18.41 7.96696C18.8661 7.6615 19.4026 7.49845 19.9516 7.49843C20.3148 7.49344 20.6753 7.56089 21.0121 7.69687C21.349 7.83286 21.6553 8.03461 21.9133 8.29037C22.1712 8.54612 22.3756 8.85078 22.5144 9.18644C22.6532 9.5221 22.7238 9.88212 22.7219 10.2454ZM21.8453 10.2454C21.8306 9.87807 21.7083 9.52321 21.4935 9.22489C21.2787 8.92657 20.981 8.69791 20.6374 8.56743C20.2937 8.43694 19.9193 8.41038 19.5607 8.49098C19.2021 8.57158 18.875 8.75576 18.6202 9.02073C18.3655 9.28569 18.1942 9.61971 18.1277 9.98123C18.0612 10.3428 18.1025 10.7158 18.2464 11.0541C18.3902 11.3924 18.6303 11.6809 18.9368 11.8838C19.2433 12.0867 19.6027 12.195 19.9703 12.1953C20.2217 12.1911 20.4697 12.1371 20.7001 12.0367C20.9306 11.9363 21.1389 11.7913 21.3132 11.6101C21.4874 11.4289 21.6241 11.2151 21.7155 10.9809C21.8068 10.7467 21.8509 10.4967 21.8453 10.2454Z"
        fill="#DF854F"
      />
      <path
        d="M13.1922 0.03125C13.1922 0.03125 11.1812 1.71878 11.1812 3.8094C11.1831 4.35385 11.3397 4.8865 11.6326 5.34543C11.9256 5.80435 12.3429 6.17057 12.8359 6.40149C13 6.46711 13.1922 6.56091 13.1922 6.56091C13.1922 6.56091 15.2078 5.90472 15.2078 3.8094C15.2078 1.71409 13.1922 0.03125 13.1922 0.03125Z"
        fill="#DF854F"
      />
      <path
        d="M15.4938 5.50622C15.6299 5.27727 15.7206 5.02417 15.7609 4.76086H25.5578V15.7859H0.8125V4.76086H10.6141C10.6515 5.02419 10.7407 5.27753 10.8766 5.50622H1.56719V15.0406H24.8219V5.50622H15.4938Z"
        fill="#DF854F"
      />
    </svg>
  );
};
export const MagnifyingGlass = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.026 22.4582C18.2353 22.4582 22.4582 18.2353 22.4582 13.026C22.4582 7.81671 18.2353 3.59375 13.026 3.59375C7.81671 3.59375 3.59375 7.81671 3.59375 13.026C3.59375 18.2353 7.81671 22.4582 13.026 22.4582Z"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6973 19.6953L25.1546 25.1526"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const FilledPaymentIcon = () => {
  return (
    <svg
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="44.5" cy="44" r="44" fill="#198000" />
      <path
        d="M68.5 26H20.5C19.3954 26 18.5 26.8954 18.5 28V60C18.5 61.1046 19.3954 62 20.5 62H68.5C69.6046 62 70.5 61.1046 70.5 60V28C70.5 26.8954 69.6046 26 68.5 26Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.7227 55.2197C53.7227 54.1152 54.6181 53.2197 55.7227 53.2197H63.7227C64.8272 53.2197 65.7227 54.1152 65.7227 55.2197C65.7227 56.3243 64.8272 57.2197 63.7227 57.2197H55.7227C54.6181 57.2197 53.7227 56.3243 53.7227 55.2197Z"
        fill="#198000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.7227 55.2197C43.7227 54.1152 44.6181 53.2197 45.7227 53.2197H49.7227C50.8272 53.2197 51.7227 54.1152 51.7227 55.2197C51.7227 56.3243 50.8272 57.2197 49.7227 57.2197H45.7227C44.6181 57.2197 43.7227 56.3243 43.7227 55.2197Z"
        fill="#198000"
      />
      <rect x="18.5" y="34" width="52" height="4" fill="#198000" />
    </svg>
  );
};
export const EditPencil = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6605 4.00293C17.2189 4.00293 16.7818 4.09072 16.3744 4.26128C15.9679 4.43147 15.5992 4.68065 15.2897 4.99425L4.97843 15.3121C4.88348 15.4071 4.81579 15.5259 4.78243 15.656L3.52351 20.5667C3.45769 20.8234 3.53227 21.0958 3.71967 21.2832C3.90708 21.4707 4.17949 21.5452 4.43623 21.4794L9.35091 20.2197C9.4812 20.1863 9.60012 20.1185 9.69519 20.0234L20.0058 9.70623C20.3201 9.39709 20.57 9.02849 20.7407 8.62186C20.9118 8.21405 21 7.7762 21 7.33388C21 6.89156 20.9118 6.45371 20.7407 6.04589C20.5695 5.63805 20.3187 5.26847 20.0029 4.95877C19.9796 4.93589 19.9552 4.91484 19.9298 4.89561C19.6423 4.6281 19.3095 4.41321 18.9466 4.26128C18.5393 4.09072 18.1021 4.00293 17.6605 4.00293ZM18.9648 6.04903C18.983 6.06747 19.0019 6.08478 19.0214 6.10095C19.1626 6.25535 19.2764 6.43306 19.3576 6.62647C19.4516 6.85045 19.5 7.09093 19.5 7.33388C19.5 7.57683 19.4516 7.81731 19.3576 8.04129C19.2636 8.26524 19.1258 8.46817 18.9525 8.63819L18.9525 8.63816L18.9472 8.64343L18.5636 9.02732L17.5318 7.99549L15.9792 6.4263L16.3525 6.05282L16.3525 6.05284L16.3562 6.04903C16.5267 5.87599 16.7298 5.73863 16.9536 5.64491C17.1775 5.55119 17.4178 5.50293 17.6605 5.50293C17.9032 5.50293 18.1435 5.55119 18.3674 5.64491C18.5913 5.73865 18.7944 5.87602 18.9648 6.04903ZM14.9189 7.48731L6.18448 16.2273L5.29117 19.7118L8.77944 18.8177L17.5033 10.0883L16.4697 9.05474L16.4669 9.05191L16.4669 9.0519L14.9189 7.48731Z"
        fill="#198000"
      />
    </svg>
  );
};
export const Receipt = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82113 2.82113C5.18684 2.45543 5.68284 2.25 6.2 2.25H18.2C18.7172 2.25 19.2132 2.45543 19.5789 2.82113C19.9446 3.18684 20.15 3.68284 20.15 4.2V21C20.15 21.3033 19.9673 21.5768 19.687 21.6929C19.4068 21.809 19.0842 21.7448 18.8697 21.5303L17 19.6607L15.1303 21.5303C14.9897 21.671 14.7989 21.75 14.6 21.75C14.4011 21.75 14.2103 21.671 14.0697 21.5303L12.2 19.6607L10.3303 21.5303C10.1897 21.671 9.99891 21.75 9.8 21.75C9.60109 21.75 9.41032 21.671 9.26967 21.5303L7.4 19.6607L5.53033 21.5303C5.31583 21.7448 4.99324 21.809 4.71299 21.6929C4.43273 21.5768 4.25 21.3033 4.25 21V4.2C4.25 3.68284 4.45543 3.18684 4.82113 2.82113ZM6.2 3.75C6.08064 3.75 5.96618 3.79741 5.88179 3.88179C5.79741 3.96618 5.75 4.08064 5.75 4.2V19.1893L6.86967 18.0697C7.01032 17.929 7.20109 17.85 7.4 17.85C7.59891 17.85 7.78968 17.929 7.93033 18.0697L9.8 19.9393L11.6697 18.0697C11.8103 17.929 12.0011 17.85 12.2 17.85C12.3989 17.85 12.5897 17.929 12.7303 18.0697L14.6 19.9393L16.4697 18.0697C16.6103 17.929 16.8011 17.85 17 17.85C17.1989 17.85 17.3897 17.929 17.5303 18.0697L18.65 19.1893V4.2C18.65 4.08064 18.6026 3.96618 18.5182 3.88179C18.4338 3.79741 18.3194 3.75 18.2 3.75H6.2ZM6.64996 7.19998C6.64996 6.78577 6.98575 6.44998 7.39996 6.44998H12.2C12.6142 6.44998 12.95 6.78577 12.95 7.19998C12.95 7.6142 12.6142 7.94998 12.2 7.94998H7.39996C6.98575 7.94998 6.64996 7.6142 6.64996 7.19998ZM7.39996 10.05C6.98575 10.05 6.64996 10.3858 6.64996 10.8C6.64996 11.2142 6.98575 11.55 7.39996 11.55H12.2C12.6142 11.55 12.95 11.2142 12.95 10.8C12.95 10.3858 12.6142 10.05 12.2 10.05H7.39996ZM6.64996 14.4C6.64996 13.9858 6.98575 13.65 7.39996 13.65H12.2C12.6142 13.65 12.95 13.9858 12.95 14.4C12.95 14.8142 12.6142 15.15 12.2 15.15H7.39996C6.98575 15.15 6.64996 14.8142 6.64996 14.4ZM17.0672 7.75752C16.9478 7.79737 16.8214 7.81183 16.6961 7.8C16.472 7.77886 16.2639 7.67489 16.1124 7.50845C15.9609 7.34201 15.877 7.12505 15.877 6.9C15.877 6.67495 15.9609 6.458 16.1124 6.29156C16.2639 6.12511 16.472 6.02115 16.6961 6C16.8214 5.98818 16.9478 6.00263 17.0672 6.04248C17.1866 6.08233 17.2964 6.14668 17.3895 6.2314C17.4826 6.31612 17.5569 6.4194 17.6078 6.53453C17.6587 6.64966 17.685 6.77413 17.685 6.9C17.685 7.02588 17.6587 7.15035 17.6078 7.26548C17.5569 7.38061 17.4826 7.48388 17.3895 7.56861C17.2964 7.65333 17.1866 7.71767 17.0672 7.75752ZM16.1124 9.89153C16.2639 9.72509 16.472 9.62113 16.6961 9.59998C16.8214 9.58815 16.9478 9.60261 17.0672 9.64246C17.1866 9.68231 17.2964 9.74665 17.3895 9.83138C17.4826 9.9161 17.5569 10.0194 17.6078 10.1345C17.6587 10.2496 17.685 10.3741 17.685 10.5C17.685 10.6259 17.6587 10.7503 17.6078 10.8655C17.5569 10.9806 17.4826 11.0839 17.3895 11.1686C17.2964 11.2533 17.1866 11.3176 17.0672 11.3575C16.9478 11.3973 16.8214 11.4118 16.6961 11.4C16.472 11.3788 16.2639 11.2749 16.1124 11.1084C15.9609 10.942 15.877 10.725 15.877 10.5C15.877 10.2749 15.9609 10.058 16.1124 9.89153ZM16.6961 13.2C16.472 13.2212 16.2639 13.3252 16.1124 13.4916C15.9609 13.658 15.877 13.875 15.877 14.1C15.877 14.3251 15.9609 14.5421 16.1124 14.7085C16.2639 14.8749 16.472 14.9789 16.6961 15C16.8214 15.0119 16.9478 14.9974 17.0672 14.9576C17.1866 14.9177 17.2964 14.8534 17.3895 14.7687C17.4826 14.6839 17.5569 14.5807 17.6078 14.4655C17.6587 14.3504 17.685 14.2259 17.685 14.1C17.685 13.9742 17.6587 13.8497 17.6078 13.7346C17.5569 13.6194 17.4826 13.5162 17.3895 13.4314C17.2964 13.3467 17.1866 13.2824 17.0672 13.2425C16.9478 13.2027 16.8214 13.1882 16.6961 13.2Z"
        fill="#198000"
      />
    </svg>
  );
};
export const FilledRecentOrderIcon = () => {
  return (
    <svg
      width="89"
      height="88"
      viewBox="0 0 89 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="44.5" cy="44" r="44" fill="#198000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.9208 26.8044C53.6407 23.5921 48.3164 22.0915 42.9887 22.5957C37.661 23.0999 32.7128 25.5728 29.1113 29.5311C25.5098 33.4893 23.5139 38.6485 23.5137 44C23.5137 44.5523 23.066 45 22.5137 44.9999C21.9614 44.9999 21.5137 44.5522 21.5137 43.9999C21.514 38.1506 23.6955 32.5116 27.632 28.1851C31.5685 23.8586 36.977 21.1557 42.8003 20.6046C48.6235 20.0535 54.4431 21.6937 59.1213 25.2048C63.7996 28.716 67.0003 33.8456 68.0979 39.591C69.1955 45.3364 68.1111 51.2848 65.0565 56.2732C62.002 61.2616 57.1969 64.9315 51.5806 66.5658C45.9642 68.2 39.9402 67.6812 34.6861 65.1104C30.2938 62.9613 26.7034 59.5074 24.3839 55.2555L22.3712 63.6617C22.2426 64.1988 21.7029 64.53 21.1658 64.4014C20.6287 64.2728 20.2976 63.7331 20.4262 63.196L23.0871 52.0826C23.1513 51.8144 23.3234 51.5846 23.5627 51.4476C23.5845 51.4352 23.6066 51.4236 23.629 51.4129C23.6614 51.3957 23.695 51.3801 23.7299 51.3663C24.0313 51.2468 24.3562 51.284 24.6142 51.439L35.2689 54.685C35.7972 54.846 36.095 55.4048 35.934 55.9331C35.7731 56.4614 35.2143 56.7592 34.686 56.5982L25.9467 53.9357C28.0598 57.9917 31.4226 61.2871 35.5651 63.3139C40.3721 65.6659 45.8834 66.1406 51.0218 64.6454C56.1602 63.1502 60.5563 59.7926 63.3509 55.2288C66.1455 50.6649 67.1376 45.2227 66.1335 39.9663C65.1293 34.7098 62.2009 30.0168 57.9208 26.8044ZM43.4384 29C43.9907 29 44.4384 29.4477 44.4384 30L44.4383 45.033H55.2914C55.8437 45.033 56.2914 45.4807 56.2914 46.033C56.2914 46.5853 55.8437 47.033 55.2914 47.033H43.4382C43.173 47.033 42.9187 46.9277 42.7311 46.7401C42.5436 46.5526 42.4382 46.2982 42.4382 46.033L42.4384 30C42.4384 29.4477 42.8861 29 43.4384 29Z"
        fill="white"
      />
    </svg>
  );
};
export const TrashIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71387 5.93579C5.50409 5.93579 5.3039 6.02365 5.16188 6.17804C5.01986 6.33243 4.949 6.53925 4.96648 6.7483L6.02554 19.4112L6.02571 19.4133C6.06659 19.8863 6.28302 20.3268 6.63239 20.6483C6.98185 20.9698 7.43893 21.1487 7.9136 21.1501L7.91579 21.1501H16.0899H16.091V20.4002L16.0886 21.1501L16.0899 21.1501C16.5662 21.1513 17.0255 20.973 17.3762 20.6503C17.7269 20.3277 17.943 19.8847 17.9814 19.4098L17.9815 19.4087L19.0327 6.74785C19.0501 6.53887 18.9791 6.33217 18.8371 6.17788C18.6951 6.02358 18.495 5.93579 18.2853 5.93579H5.71387ZM7.52014 19.2842L6.52921 7.43579H17.4704L16.4864 19.2867L16.4863 19.2887C16.4784 19.3874 16.4335 19.4794 16.3607 19.5464C16.2879 19.6133 16.1925 19.6504 16.0934 19.6501L16.091 19.6501H7.91722C7.81736 19.6496 7.72136 19.6119 7.64798 19.5444C7.57452 19.4768 7.52898 19.3843 7.52021 19.2849L7.52014 19.2842ZM10.2855 9.93579C10.6997 9.93579 11.0355 10.2716 11.0355 10.6858V16.4001C11.0355 16.8143 10.6997 17.1501 10.2855 17.1501C9.87131 17.1501 9.53552 16.8143 9.53552 16.4001V10.6858C9.53552 10.2716 9.87131 9.93579 10.2855 9.93579ZM13.7139 9.93579C14.1281 9.93579 14.4639 10.2716 14.4639 10.6858V16.4001C14.4639 16.8143 14.1281 17.1501 13.7139 17.1501C13.2997 17.1501 12.9639 16.8143 12.9639 16.4001V10.6858C12.9639 10.2716 13.2997 9.93579 13.7139 9.93579Z"
        fill="#198000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2 2.8999C9.62178 2.8999 9.11183 3.18831 8.76581 3.62083C8.42318 4.04912 8.25 4.60061 8.25 5.1499V5.93571H4C3.58579 5.93571 3.25 6.2715 3.25 6.68571C3.25 7.09993 3.58579 7.43571 4 7.43571H20C20.4142 7.43571 20.75 7.09993 20.75 6.68571C20.75 6.2715 20.4142 5.93571 20 5.93571H15.75V5.1499C15.75 4.60061 15.5768 4.04912 15.2342 3.62083C14.8882 3.18831 14.3782 2.8999 13.8 2.8999H10.2ZM10.2 4.3999H13.8C13.8583 4.3999 13.9588 4.42779 14.0629 4.55788C14.1703 4.6922 14.25 4.90354 14.25 5.1499V5.8999H9.75V5.1499C9.75 4.90354 9.82966 4.6922 9.93712 4.55788C10.0412 4.42779 10.1417 4.3999 10.2 4.3999Z"
        fill="#198000"
      />
    </svg>
  );
};
export const TimerIcon = ({ height, width, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.0878 12.8159C25.0878 19.0335 19.6871 24.1572 12.9189 24.1572C6.15065 24.1572 0.75 19.0335 0.75 12.8159C0.75 6.59828 6.15065 1.47461 12.9189 1.47461C19.6871 1.47461 25.0878 6.59828 25.0878 12.8159Z"
        stroke="#198000"
        strokeWidth="1.5"
      />
      <path
        d="M11.8438 8.46094V14.5066H17.0113"
        stroke="#198000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RewardIcon = ({ height, width, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13 13.806V20.1642C13 20.2461 12.9766 20.3265 12.932 20.3972C12.8875 20.4679 12.8235 20.5265 12.7465 20.5668C12.6696 20.6072 12.5824 20.6279 12.4939 20.6269C12.4055 20.6259 12.3189 20.6032 12.243 20.5612L8 18.2055L3.757 20.5612C3.68104 20.6033 3.59436 20.626 3.50581 20.6269C3.41727 20.6279 3.33004 20.6071 3.25304 20.5666C3.17605 20.5261 3.11205 20.4675 3.06759 20.3966C3.02313 20.3258 2.9998 20.2452 3 20.1633V13.8069C1.70615 12.8485 0.765992 11.5419 0.309459 10.0676C-0.147074 8.59342 -0.0974441 7.02439 0.451491 5.5774C1.00043 4.13041 2.02156 2.87689 3.37378 1.99008C4.726 1.10327 6.34254 0.626953 8 0.626953C9.65746 0.626953 11.274 1.10327 12.6262 1.99008C13.9784 2.87689 14.9996 4.13041 15.5485 5.5774C16.0974 7.02439 16.1471 8.59342 15.6905 10.0676C15.234 11.5419 14.2938 12.8476 13 13.806ZM5 14.8913V17.7133L8 16.0479L11 17.7133V14.8913C10.0468 15.248 9.02816 15.4308 8 15.4298C6.97184 15.4308 5.95316 15.248 5 14.8913ZM8 13.5793C9.5913 13.5793 11.1174 12.9945 12.2426 11.9534C13.3679 10.9123 14 9.50024 14 8.02792C14 6.55559 13.3679 5.14356 12.2426 4.10247C11.1174 3.06138 9.5913 2.4765 8 2.4765C6.4087 2.4765 4.88258 3.06138 3.75736 4.10247C2.63214 5.14356 2 6.55559 2 8.02792C2 9.50024 2.63214 10.9123 3.75736 11.9534C4.88258 12.9945 6.4087 13.5793 8 13.5793Z"
        fill="#198000"
      />
    </svg>
  );
};
export const Heart = () => {
  return (
    <svg
      width="31"
      height="28"
      viewBox="0 0 31 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3643 26.2813C15.3643 26.2813 1 18.2372 1 8.46947C1.00029 6.74307 1.59849 5.07005 2.6929 3.73486C3.78731 2.39967 5.31037 1.48473 7.00313 1.14558C8.69589 0.806437 10.4539 1.06403 11.9782 1.87456C13.5025 2.68509 14.699 3.99853 15.3644 5.59157L15.3643 5.59158C16.0297 3.99854 17.2262 2.6851 18.7505 1.87457C20.2748 1.06403 22.0328 0.806438 23.7255 1.14558C25.4183 1.48472 26.9414 2.39967 28.0358 3.73486C29.1302 5.07005 29.7284 6.74307 29.7287 8.46947C29.7287 18.2372 15.3643 26.2813 15.3643 26.2813Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Veg = () => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7877 0.572485C17.2493 0.0143856 12.0884 0.302425 10.186 5.2113L6.82543 13.2767L2.81672 3.67499H0.818359L5.93127 15.6771H7.73159L11.4463 7.00562C11.774 7.05479 12.105 7.07893 12.4364 7.0777C13.1581 7.07531 13.8763 6.97834 14.5728 6.78951C16.2291 6.33943 18.5875 5.1273 20.3879 1.92273L20.988 0.854518L19.7877 0.572485ZM12.1904 5.24134C13.5826 2.54686 16.3491 2.17479 18.0114 2.2408C15.875 5.08531 13.2706 5.29535 12.1904 5.24134Z"
        fill="#85A079"
      />
    </svg>
  );
};
export const BlackCross = ({ stroke, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_912_129151)">
        <path
          d="M25.8887 7.13672L7.88867 25.1367"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.8887 25.1367L7.88867 7.13672"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_912_129151">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.888672 0.136719)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FooterFbIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23755_4521)">
        <path
          d="M5.35026 39V20.7001H0.5V14.1112H5.35026V8.48347C5.35026 4.06115 8.21533 0 14.8171 0C17.49 0 19.4665 0.255645 19.4665 0.255645L19.3108 6.40852C19.3108 6.40852 17.295 6.38894 15.0954 6.38894C12.7147 6.38894 12.3333 7.48348 12.3333 9.30013V14.1112H19.5L19.1882 20.7001H12.3333V39H5.35026Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23755_4521">
          <rect
            width="19"
            height="39"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FooterInstaIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 45 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23755_4523)">
        <path
          d="M22.5 28.875C26.297 28.875 29.375 25.797 29.375 22C29.375 18.203 26.297 15.125 22.5 15.125C18.703 15.125 15.625 18.203 15.625 22C15.625 25.797 18.703 28.875 22.5 28.875Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M30.0625 6.1875H14.9375C10.3812 6.1875 6.6875 9.88115 6.6875 14.4375V29.5625C6.6875 34.1188 10.3812 37.8125 14.9375 37.8125H30.0625C34.6188 37.8125 38.3125 34.1188 38.3125 29.5625V14.4375C38.3125 9.88115 34.6188 6.1875 30.0625 6.1875Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.4375 15.125C32.5766 15.125 33.5 14.2016 33.5 13.0625C33.5 11.9234 32.5766 11 31.4375 11C30.2984 11 29.375 11.9234 29.375 13.0625C29.375 14.2016 30.2984 15.125 31.4375 15.125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23755_4523">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FooterPintresrIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23755_4529)">
        <path
          d="M0.5 17C0.5 24.2576 4.91512 30.4541 11.1287 32.8922C10.9775 31.5648 10.8166 29.376 11.1631 27.8403C11.4615 26.52 13.0895 19.4282 13.0895 19.4282C13.0895 19.4282 12.5986 18.4152 12.5986 16.915C12.5986 14.5633 13.9214 12.8067 15.57 12.8067C16.9725 12.8067 17.649 13.8904 17.649 15.1895C17.649 16.6416 16.7511 18.8119 16.2878 20.825C15.9014 22.5094 17.1086 23.8836 18.7201 23.8836C21.6392 23.8836 23.8846 20.7117 23.8846 16.133C23.8846 12.0799 21.0576 9.248 17.022 9.248C12.3497 9.248 9.60663 12.8591 9.60663 16.592C9.60663 18.0469 10.1497 19.6052 10.829 20.4538C10.8869 20.5179 10.9278 20.5963 10.9478 20.6814C10.9678 20.7665 10.9662 20.8555 10.9431 20.9397C10.818 21.4753 10.5402 22.6242 10.4866 22.8593C10.4137 23.1682 10.2487 23.2347 9.93662 23.0846C7.88512 22.1014 6.60363 19.0117 6.60363 16.5297C6.60363 11.1903 10.367 6.28858 17.4551 6.28858C23.1531 6.28858 27.582 10.472 27.582 16.0622C27.582 21.8946 24.0139 26.5894 19.0584 26.5894C17.3932 26.5894 15.8299 25.6969 15.2936 24.6443C15.2936 24.6443 14.47 27.8772 14.2706 28.6677C13.8829 30.2033 12.8076 32.147 12.1407 33.2506C13.678 33.7379 15.3088 34 17 34C26.1121 34 33.5 26.3882 33.5 17C33.5 7.61175 26.1121 0 17 0C7.88788 0 0.5 7.61175 0.5 17Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23755_4529">
          <rect
            width="33"
            height="34"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FooterTwitterIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.9801 7.19988C33.7624 7.73947 32.4543 8.10405 31.0791 8.26884C32.498 7.41979 33.5596 6.08348 34.0657 4.50926C32.7326 5.30112 31.2735 5.8585 29.752 6.15718C28.7288 5.06469 27.3735 4.34057 25.8966 4.09724C24.4197 3.85392 22.9038 4.105 21.5842 4.8115C20.2646 5.51801 19.2152 6.64041 18.5989 8.00445C17.9825 9.36849 17.8338 10.8979 18.1757 12.3551C15.4744 12.2195 12.8319 11.5174 10.4195 10.2943C8.00709 9.07131 5.87883 7.3547 4.17281 5.25593C3.58948 6.26218 3.25406 7.42884 3.25406 8.67134C3.25341 9.78988 3.52886 10.8913 4.05597 11.8778C4.58308 12.8644 5.34555 13.7056 6.27573 14.3268C5.19697 14.2924 4.142 14.0009 3.19865 13.4766V13.5641C3.19854 15.1328 3.74119 16.6534 4.73454 17.8676C5.72788 19.0818 7.11073 19.915 8.64844 20.2257C7.64771 20.4966 6.59851 20.5364 5.5801 20.3424C6.01395 21.6922 6.85906 22.8726 7.9971 23.7183C9.13514 24.564 10.5091 25.0326 11.9268 25.0586C9.52028 26.9478 6.54827 27.9725 3.48885 27.968C2.94691 27.9682 2.40542 27.9365 1.86719 27.8732C4.97267 29.8699 8.58768 30.9296 12.2797 30.9255C24.7776 30.9255 31.6099 20.5743 31.6099 11.5968C31.6099 11.3051 31.6026 11.0105 31.5895 10.7188C32.9184 9.75776 34.0656 8.56765 34.9772 7.20426L34.9801 7.19988Z"
        fill="white"
      />
    </svg>
  );
};
export const CateringUser: FC<any> = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="#198000" />
      <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="white" />
      <path
        d="M17.9992 11C13.36 11 9.59961 14.306 9.59961 18.3846C9.59961 18.5918 9.60972 18.7969 9.62916 19H26.3701C26.3895 18.7969 26.3996 18.5918 26.3996 18.3846C26.3988 14.306 22.6384 11 17.9992 11Z"
        fill="white"
        stroke="#198000"
        strokeMiterlimit="10"
      />
      <path
        d="M28.4145 22H7.58591C7.373 22 7.2002 21.8208 7.2002 21.6V20.4C7.2002 20.1792 7.373 20 7.58591 20H28.4145C28.6274 20 28.8002 20.1792 28.8002 20.4V21.6C28.8002 21.8208 28.6274 22 28.4145 22Z"
        fill="white"
        stroke="white"
        strokeMiterlimit="10"
      />
      <rect
        x="15.8496"
        y="10.25"
        width="4.3"
        height="0.5"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
};
export const IndividualUser: FC<any> = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="-0.5"
        y="0.5"
        width="35"
        height="35"
        rx="17.5"
        transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 35 -4.37114e-08)"
        fill="#4C86A0"
      />
      <path
        d="M18 18C15.2386 18 13 15.7614 13 13C13 10.2386 15.2386 8 18 8C20.7614 8 23 10.2386 23 13C23 15.7614 20.7614 18 18 18Z"
        fill="white"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M28 25C27.0614 23.1946 25.6304 21.6784 23.8654 20.6195C22.1005 19.5605 20.0704 19 18 19C15.9296 19 13.8995 19.5605 12.1346 20.6195C10.3696 21.6784 8.93864 23.1945 8 25"
        fill="white"
      />
      <path
        d="M28 25C27.0614 23.1946 25.6304 21.6784 23.8654 20.6195C22.1005 19.5605 20.0704 19 18 19C15.9296 19 13.8995 19.5605 12.1346 20.6195C10.3696 21.6784 8.93864 23.1945 8 25"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 25L28 25" stroke="white" />
      <rect
        x="-0.5"
        y="0.5"
        width="35"
        height="35"
        rx="17.5"
        transform="matrix(-1 -8.74228e-08 -8.74228e-08 1 35 -4.37114e-08)"
        stroke="white"
      />
    </svg>
  );
};
export const UserCircle: FC<any> = ({ className }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 19.25C6.44365 19.25 2.75 15.5563 2.75 11C2.75 6.44364 6.44365 2.74999 11 2.74999C15.5563 2.74999 19.25 6.44364 19.25 11C19.25 15.5563 15.5563 19.25 11 19.25Z"
        stroke="#3D3935"
        strokeMiterlimit="10"
      />
      <path
        d="M11 13.75C9.10152 13.75 7.5625 12.211 7.5625 10.3125C7.5625 8.41401 9.10152 6.87499 11 6.87499C12.8985 6.87499 14.4375 8.41401 14.4375 10.3125C14.4375 12.211 12.8985 13.75 11 13.75Z"
        stroke="#3D3935"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5176 17.1337C15.9997 16.1155 15.2102 15.2605 14.2364 14.6633C13.2627 14.0661 12.1426 13.75 11.0003 13.75C9.85801 13.75 8.73798 14.0661 7.76421 14.6633C6.79044 15.2605 6.00093 16.1155 5.48305 17.1337"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PasswordIcons = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.344 12.4357C3.1965 12.2718 3.06928 12.1249 2.96382 12C3.06928 11.8751 3.1965 11.7282 3.344 11.5643C3.83261 11.0217 4.53911 10.2987 5.40955 9.57752C7.17181 8.11735 9.50256 6.75 12 6.75C14.4974 6.75 16.8282 8.11735 18.5905 9.57752C19.4609 10.2987 20.1674 11.0217 20.656 11.5643C20.8035 11.7282 20.9307 11.8751 21.0362 12C20.9307 12.1249 20.8035 12.2718 20.656 12.4357C20.1674 12.9783 19.4609 13.7013 18.5905 14.4225C16.8282 15.8826 14.4974 17.25 12 17.25C9.50256 17.25 7.17181 15.8826 5.40955 14.4225C4.53911 13.7013 3.83261 12.9783 3.344 12.4357ZM22.6005 11.5507C22.6007 11.5509 22.6008 11.5511 22 12C22.6008 12.4489 22.6007 12.4491 22.6005 12.4493L22.6001 12.4499L22.599 12.4514L22.5955 12.456L22.5835 12.4718C22.5734 12.485 22.559 12.5039 22.5403 12.5278C22.503 12.5758 22.4488 12.6445 22.3786 12.7309C22.2382 12.9036 22.0333 13.1477 21.7707 13.4393C21.2464 14.0217 20.4874 14.7987 19.5475 15.5775C17.6891 17.1174 15.0198 18.75 12 18.75C8.98019 18.75 6.31095 17.1174 4.45252 15.5775C3.51261 14.7987 2.75359 14.0217 2.22927 13.4393C1.96668 13.1477 1.76181 12.9036 1.6214 12.7309C1.55116 12.6445 1.49698 12.5758 1.45968 12.5278C1.44102 12.5039 1.42659 12.485 1.41647 12.4718L1.40454 12.456L1.40103 12.4514L1.3999 12.4499L1.39948 12.4493C1.39932 12.4491 1.39917 12.4489 2 12C1.39917 11.5511 1.39932 11.5509 1.39948 11.5507L1.3999 11.5501L1.40103 11.5486L1.40454 11.544L1.41647 11.5282C1.42659 11.515 1.44102 11.4961 1.45968 11.4722C1.49698 11.4242 1.55116 11.3555 1.6214 11.2691C1.76181 11.0964 1.96668 10.8523 2.22927 10.5607C2.75359 9.97833 3.51261 9.20127 4.45252 8.42248C6.31095 6.88265 8.98019 5.25 12 5.25C15.0198 5.25 17.6891 6.88265 19.5475 8.42248C20.4874 9.20127 21.2464 9.97833 21.7707 10.5607C22.0333 10.8523 22.2382 11.0964 22.3786 11.2691C22.4488 11.3555 22.503 11.4242 22.5403 11.4722C22.559 11.4961 22.5734 11.515 22.5835 11.5282L22.5955 11.544L22.599 11.5486L22.6001 11.5501L22.6005 11.5507ZM22 12L22.6008 11.5511C22.7997 11.8173 22.7997 12.1827 22.6008 12.4489L22 12ZM1.39917 11.5511L2 12L1.39917 12.4489C1.20028 12.1827 1.20028 11.8173 1.39917 11.5511ZM9.74998 12C9.74998 10.7574 10.7573 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7573 14.25 9.74998 13.2426 9.74998 12ZM12 8.25C9.92892 8.25 8.24998 9.92893 8.24998 12C8.24998 14.0711 9.92892 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25Z"
        fill="#198000"
      />
    </svg>
  );
};
export const HideIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.977 3.25C20.1755 3.25 20.3659 3.32889 20.5063 3.46934C20.6466 3.60997 20.7254 3.80059 20.7254 3.99934C20.7254 4.19809 20.6466 4.38871 20.5063 4.52934L4.52598 20.5293C4.38553 20.6698 4.19514 20.7487 3.99663 20.7487C3.79813 20.7487 3.60774 20.6698 3.46728 20.5293C3.32701 20.3887 3.24821 20.1981 3.24821 19.9993C3.24821 19.8006 3.32701 19.61 3.46728 19.4693L19.4476 3.46934C19.5881 3.32889 19.7785 3.25 19.977 3.25ZM5.69453 16.5293L6.78319 15.4393C5.37146 14.4698 4.098 13.3125 2.99785 11.9993C4.12646 10.6493 7.79195 6.74933 11.9868 6.74933C12.9795 6.76419 13.9612 6.96076 14.8832 7.32933L16.0318 6.17933C14.7648 5.58515 13.3858 5.26811 11.9868 5.24933C6.16396 5.24933 1.58958 11.2493 1.39982 11.5493C1.30257 11.6792 1.25 11.8371 1.25 11.9993C1.25 12.1616 1.30257 12.3195 1.39982 12.4493C2.62704 14.0099 4.07364 15.3842 5.69453 16.5293ZM22.5738 11.5493C21.3445 9.98708 19.8944 8.61263 18.2691 7.46933L17.1904 8.55933C18.599 9.53274 19.872 10.6896 20.9757 11.9993C19.8371 13.3493 16.1716 17.2493 11.9868 17.2493C10.9941 17.2345 10.0124 17.0379 9.09036 16.6693L7.99171 17.8193C9.25876 18.4135 10.6377 18.7306 12.0367 18.7493C17.8596 18.7493 22.4339 12.7493 22.6237 12.4493C22.7139 12.3142 22.7579 12.1533 22.7488 11.991C22.7398 11.8287 22.6784 11.6737 22.5738 11.5493ZM11.9868 9.74933C12.1331 9.73901 12.2799 9.73901 12.4263 9.74933L13.5948 8.58933C13.0919 8.35425 12.5417 8.23793 11.9868 8.24933C10.9935 8.24933 10.0408 8.64442 9.3384 9.34768C8.636 10.0509 8.2414 11.0048 8.2414 11.9993C8.24246 12.5581 8.37235 13.1091 8.62093 13.6093L9.77951 12.4393C9.7692 12.2928 9.7692 12.1458 9.77951 11.9993C9.77942 11.4095 10.0107 10.8431 10.4235 10.4223C10.8364 10.0015 11.3977 9.75982 11.9868 9.74933ZM11.5473 14.2493C11.6937 14.2597 11.8405 14.2597 11.9868 14.2493C12.5759 14.2389 13.1372 13.9972 13.5501 13.5764C13.9629 13.1555 14.1942 12.5892 14.1941 11.9993C14.2044 11.8529 14.2044 11.7058 14.1941 11.5593L15.3527 10.3893C15.6013 10.8896 15.7311 11.4406 15.7322 11.9993C15.7375 12.4952 15.6445 12.9871 15.4586 13.4467C15.2728 13.9063 14.9977 14.3244 14.6494 14.6769C14.3011 15.0294 13.8864 15.3092 13.4294 15.5001C12.9724 15.6911 12.482 15.7894 11.9868 15.7893C11.4287 15.7883 10.8784 15.6582 10.3788 15.4093L11.5473 14.2493Z"
        fill="#D2D2D2"
      ></path>
    </svg>
  );
};
export const MapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="82"
      viewBox="0 0 54 82"
      fill="none"
    >
      <g clipPath="url(#clip0_24205_186421)">
        <path
          d="M27 0C12.1016 0 0 12.2761 0 27.3688C0 42.5146 14.253 68.9268 27.3765 82C40.1773 69.2988 53.9462 42.5146 53.9462 27.3688C54 12.2761 41.8984 0 27 0Z"
          fill="#9D2931"
        />
        <path
          d="M44.964 25.9879C44.9102 25.6159 44.5337 25.2971 44.1572 25.2971H44.1034C43.2428 20.7268 39.3165 17.1662 34.5297 16.9004C37.2189 16.1033 38.2409 14.7216 39.3165 13.6056C35.6592 11.533 33.1313 11.2673 30.8185 15.3061C32.8624 10.5764 33.8305 9.8324 31.2488 6.48438C28.9899 8.82268 27.0536 10.1513 27.1074 12.2238C27.1612 14.137 27.3763 15.6782 27.3763 15.6782C27.3763 15.6782 26.3006 13.8181 25.709 11.4798C24.956 8.39753 21.7289 7.22838 20.0078 6.48438C19.4699 9.67297 19.2548 10.6295 20.2229 12.5958C20.9221 13.9776 23.0197 15.3593 23.0197 15.3593C23.0197 15.3593 18.5556 15.4124 16.6193 11.7456C15.5974 13.1804 15.5436 15.7313 17.2648 17.2193C12.4779 17.9102 8.76675 21.8959 8.65918 26.8382C8.65918 27.5822 8.71296 28.2731 8.82053 28.964C9.08946 30.9303 9.84245 32.7903 10.8106 34.544C10.4879 34.6503 10.2189 35.1817 10.4879 35.6069C11.456 37.148 12.5317 38.5297 13.6074 39.752L14.8982 41.1338C19.6851 45.9698 24.8484 48.8395 26.0855 49.1584C28.7747 49.1584 40.0695 41.3463 44.0496 31.3554C44.1034 31.196 44.1572 31.0365 44.211 30.8771C44.695 29.708 44.964 28.4325 44.964 27.0508C45.0177 26.6257 45.0177 26.3068 44.964 25.9879ZM11.456 29.3891C11.3484 28.8045 11.2946 28.22 11.2946 27.5822C11.4022 22.8525 15.3823 19.1856 20.1691 19.345C22.5895 19.4513 24.7409 20.461 26.2468 22.0553C27.8604 20.1953 30.3345 19.0793 33.0237 19.1856C36.95 19.345 40.2309 22.0022 41.199 25.5628C37.9719 26.0942 32.5934 27.5291 27.3763 31.3554C22.2668 35.1286 16.8883 35.3411 13.6612 34.9691C12.5855 33.3217 11.6711 31.4085 11.456 29.3891ZM15.8126 24.7125C15.1671 24.6594 14.952 23.7559 15.4361 22.7462C15.5974 22.3211 15.8664 21.9491 16.1891 21.6302C15.5436 21.9491 14.8982 22.6931 14.4679 23.5965C13.9301 24.8719 14.0914 25.9348 14.952 26.0411C15.7588 26.0942 16.8883 25.1376 17.4261 23.8622C17.4799 23.7028 17.5337 23.5434 17.5875 23.3839C17.1572 24.1811 16.4042 24.7656 15.8126 24.7125ZM21.2986 26.3599C20.5456 26.3599 20.1154 25.4034 20.2767 24.2874C20.3305 23.8091 20.5456 23.3839 20.7608 23.0119C20.1691 23.4371 19.6313 24.3405 19.4699 25.2971C19.2548 26.7319 19.7926 27.9011 20.707 27.848C21.6213 27.848 22.5895 26.6788 22.8046 25.2439C22.8584 25.0314 22.8584 24.8719 22.8584 24.7125C22.5895 25.6691 21.944 26.3599 21.2986 26.3599ZM17.6413 30.824C16.7807 30.9303 16.0815 29.9205 15.9739 28.6451C15.9201 28.1137 16.0277 27.6354 16.1891 27.2102C15.5974 27.7417 15.2747 28.7514 15.3285 29.8674C15.4361 31.4617 16.3504 32.6308 17.3723 32.5246C18.3942 32.4183 19.1472 31.0365 19.0934 29.4422C19.0934 29.2297 19.0397 29.0171 19.0397 28.8577C18.9321 29.9205 18.3405 30.7708 17.6413 30.824Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_24205_186421">
          <rect width="54" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MyLocaion = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.1875C13.9695 17.1875 17.1875 13.9695 17.1875 10C17.1875 6.03045 13.9695 2.8125 10 2.8125C6.03045 2.8125 2.8125 6.03045 2.8125 10C2.8125 13.9695 6.03045 17.1875 10 17.1875Z"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 2.8125V5.9375"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.8125 10H5.9375"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17.1875V14.0625"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1875 10H14.0625"
        stroke="#198000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LocationArrow = ({ className, height, width }) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="29" height="29" rx="14.5" fill="#198000" />
      <path
        d="M9 14.5C8.72386 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.72386 15.5 9 15.5L9 14.5ZM21.3536 15.3536C21.5488 15.1583 21.5488 14.8417 21.3536 14.6464L18.1716 11.4645C17.9763 11.2692 17.6597 11.2692 17.4645 11.4645C17.2692 11.6597 17.2692 11.9763 17.4645 12.1716L20.2929 15L17.4645 17.8284C17.2692 18.0237 17.2692 18.3403 17.4645 18.5355C17.6597 18.7308 17.9763 18.7308 18.1716 18.5355L21.3536 15.3536ZM9 15.5L21 15.5L21 14.5L9 14.5L9 15.5Z"
        fill="white"
      />
    </svg>
  );
};
export const InStore = ({ className, height, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="40"
      viewBox="0 0 66 40"
      fill="none"
    >
      <path
        d="M65.3529 35.6187V33.8032H57.6608V16.2524H65.3529V14.4368H57.6608V2.43567H55.7631V14.4368H38.4559V4.3481H36.2166C35.9888 2.19965 34.3188 0.529297 32.3452 0.529297C30.3716 0.529297 28.6953 2.17544 28.4675 4.3481H26.2282V14.4368H23.9067V4.3481H21.6674C21.4396 2.19965 19.7697 0.529297 17.796 0.529297C15.8224 0.529297 14.1461 2.17544 13.9184 4.3481H11.679V14.4368H8.32008V2.43567H6.42236V14.4368H0.646973V16.2524H6.42236V33.8032H0.646973V35.6187H6.42236V39.3528H8.32008V35.6187H55.7631V39.3528H57.6608V35.6187H65.3529ZM32.3452 2.33279C33.313 2.33279 34.1227 3.19823 34.3062 4.336H30.3779C30.5677 3.18007 31.3774 2.32069 32.3452 2.32069V2.33279ZM28.1259 6.1637H36.5581V13.3293H28.1259V6.1637ZM17.796 2.32069C18.7639 2.32069 19.5736 3.18612 19.757 4.3239H15.8287C16.0185 3.18007 16.8282 2.32069 17.796 2.32069ZM13.5768 6.1637H22.009V13.3293H13.5768V6.1637ZM27.0695 25.5301V32.6956H18.6373V25.5301H27.0695ZM20.8893 23.7145C21.0791 22.5707 21.8888 21.7113 22.8566 21.7113C23.8244 21.7113 24.6341 22.5767 24.8176 23.7145H20.8893ZM28.9673 33.8032V23.7145H26.728C26.5002 21.566 24.8302 19.8957 22.8566 19.8957C20.883 19.8957 19.2067 21.5418 18.9789 23.7145H16.7396V33.8032H8.32008V16.2524H55.7631V33.8032H28.9673Z"
        fill="#9D9C9A"
      />
    </svg>
  );
};
export const DeliveryCar = ({ className, height, width }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="27"
      viewBox="0 0 70 27"
      fill="none"
    >
      <path
        d="M29.0993 1.20697H10.1523V2.92526H29.0993V1.20697ZM0.764648 15.5662H7.06507V13.8479H0.764648V15.5662ZM16.1319 10.1822H5.88517V8.46391H17.1572C17.392 8.10307 17.6269 7.75941 17.8674 7.43866L18.1252 7.095H22.0314C23.4519 6.32749 24.7349 5.56571 25.9835 4.80394C29.9642 2.44987 33.1087 0.588379 36.9634 0.588379H46.0532C51.1737 0.588379 54.5702 3.85314 57.2107 7.13509C61.7355 7.85105 67.3887 10.0791 68.918 12.5649C69.1306 12.872 69.27 13.2237 69.3256 13.593C69.3812 13.9624 69.3515 14.3395 69.2387 14.6956L66.856 21.7635H59.8912C59.1745 23.0246 58.1473 24.0814 56.9071 24.8336H67.4746V26.5518H8.86928V24.8336H19.1791C18.9944 24.6596 18.8275 24.4677 18.6807 24.2608C18.161 23.5274 17.8937 22.6449 17.919 21.7463H17.644C16.1606 21.7463 15.038 21.3511 14.3105 20.6008C13.9535 20.1843 13.6888 19.6969 13.5338 19.1707C13.3788 18.6445 13.3371 18.0915 13.4113 17.548C13.5488 15.8068 14.6943 12.8055 16.1319 10.1822ZM20.0554 23.3272C20.3589 23.699 20.7472 23.9925 21.1878 24.1828C21.6284 24.3732 22.1082 24.455 22.587 24.4212C25.0785 24.4212 27.845 22.4623 28.6239 20.1426C28.8003 19.7174 28.8716 19.2559 28.8317 18.7972C28.7919 18.3386 28.642 17.8963 28.3948 17.5079C28.092 17.1353 27.7037 16.8413 27.263 16.6509C26.8223 16.4604 26.3421 16.3791 25.8632 16.4139C24.5559 16.4735 23.2928 16.9051 22.2224 17.658C21.1519 18.4108 20.3187 19.4537 19.8205 20.6638C19.6401 21.0934 19.5672 21.5605 19.6081 22.0246C19.649 22.4887 19.8025 22.9358 20.0554 23.3272ZM49.2664 24.8851C49.0852 24.7095 48.9203 24.5178 48.7738 24.3123C48.257 23.5862 47.9897 22.7119 48.0121 21.8208H46.9639H39.0311H29.758C29.0367 23.0803 28.0081 24.1365 26.7682 24.8908L49.2664 24.8851ZM58.5051 17.5079C58.2104 17.1359 57.831 16.8399 57.3986 16.6446C56.9661 16.4493 56.4932 16.3604 56.0193 16.3853C53.5278 16.3853 50.7613 18.3441 49.9824 20.6638C49.8068 21.0895 49.7365 21.5513 49.7774 22.0099C49.8182 22.4686 49.9691 22.9106 50.2172 23.2985C50.5201 23.6711 50.9083 23.9651 51.349 24.1555C51.7898 24.346 52.27 24.4273 52.7488 24.3925C55.2404 24.3925 58.0068 22.4337 58.7858 20.114C58.958 19.6865 59.0245 19.2237 58.9796 18.765C58.9347 18.3063 58.7798 17.8653 58.528 17.4792L58.5051 17.5079ZM15.1239 17.7026C15.0731 18.0112 15.086 18.3269 15.1619 18.6303C15.2377 18.9337 15.3749 19.2184 15.5649 19.4667C15.8537 19.7007 16.1865 19.8745 16.5436 19.9778C16.9007 20.0811 17.2749 20.1118 17.644 20.0681H18.2168C18.823 18.5173 19.8714 17.1787 21.2318 16.2185C22.5922 15.2582 24.2046 14.7188 25.8689 14.667C26.6177 14.6265 27.3651 14.7679 28.0474 15.0791C28.7296 15.3903 29.3264 15.862 29.7867 16.454C30.1454 16.9713 30.3879 17.5601 30.4976 18.18C30.6074 18.7999 30.5817 19.4362 30.4224 20.0452H39.0139H48.3213C48.9342 18.4916 49.9911 17.153 51.3602 16.1965C52.7292 15.24 54.3497 14.708 56.0193 14.667C56.7661 14.6293 57.5109 14.7721 58.1908 15.0831C58.8707 15.3942 59.4658 15.8644 59.9256 16.454C60.2833 16.9718 60.5248 17.5608 60.6336 18.1807C60.7423 18.8005 60.7157 19.4366 60.5556 20.0452H65.6246L67.6121 14.1629C67.6121 14.0942 67.7037 13.8823 67.4517 13.4813C66.3062 11.6542 61.2716 9.47198 56.6322 8.80184L56.2885 8.75029L56.0766 8.48682C52.5827 4.11662 49.7189 2.32959 46.0532 2.32959H36.9634C33.5841 2.32959 30.6172 4.08225 26.8598 6.30458C25.5425 7.08354 24.1793 7.89114 22.6557 8.7102L22.4667 8.8133H18.99C16.9854 11.6485 15.2671 15.8812 15.1468 17.674L15.1239 17.7026ZM50.4234 10.9783L53.1555 10.0734L52.6228 8.43527L50.1427 9.25433H32.1694L30.0444 6.3905L28.6583 7.41002L31.3045 11.0013L50.4234 10.9783Z"
        fill="#9D9C9A"
      />
    </svg>
  );
};
export const QuestionMark = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14.5C3.1339 14.5 0 11.3661 0 7.5C0 3.6339 3.1339 0.5 7 0.5C10.8661 0.5 14 3.6339 14 7.5C14 11.3661 10.8661 14.5 7 14.5ZM7 13.1C8.48521 13.1 9.90959 12.51 10.9598 11.4598C12.01 10.4096 12.6 8.98521 12.6 7.5C12.6 6.01479 12.01 4.59041 10.9598 3.5402C9.90959 2.49 8.48521 1.9 7 1.9C5.51479 1.9 4.09041 2.49 3.0402 3.5402C1.99 4.59041 1.4 6.01479 1.4 7.5C1.4 8.98521 1.99 10.4096 3.0402 11.4598C4.09041 12.51 5.51479 13.1 7 13.1ZM6.3 9.6H7.7V11H6.3V9.6ZM7.7 8.4485V8.9H6.3V7.85C6.3 7.66435 6.37375 7.4863 6.50503 7.35503C6.6363 7.22375 6.81435 7.15 7 7.15C7.19885 7.14999 7.39362 7.09351 7.56163 6.98713C7.72964 6.88075 7.86399 6.72886 7.94904 6.54911C8.03409 6.36936 8.06636 6.16916 8.04208 5.97179C8.0178 5.77442 7.93797 5.58801 7.81188 5.43424C7.6858 5.28047 7.51864 5.16566 7.32985 5.10318C7.14107 5.0407 6.93843 5.03311 6.7455 5.08129C6.55257 5.12948 6.37729 5.23146 6.24006 5.37537C6.10282 5.51928 6.00928 5.6992 5.9703 5.8942L4.5969 5.6191C4.68204 5.19356 4.87866 4.79826 5.16664 4.47361C5.45463 4.14896 5.82366 3.90661 6.23601 3.77132C6.64836 3.63604 7.08924 3.61268 7.51358 3.70363C7.93791 3.79458 8.33049 3.99658 8.65117 4.28898C8.97186 4.58138 9.20914 4.95368 9.33878 5.36784C9.46841 5.782 9.48575 6.22316 9.389 6.64622C9.29226 7.06927 9.08492 7.45905 8.78816 7.7757C8.49141 8.09236 8.11589 8.32454 7.7 8.4485Z"
        fill="#198000"
      />
    </svg>
  );
};
export const AccountDetail = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24160_196484)">
        <path
          d="M18 4H6C4.34315 4 3 5.34315 3 7V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V7C21 5.34315 19.6569 4 18 4Z"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12C10.1046 12 11 11.1046 11 10C11 8.89543 10.1046 8 9 8C7.89543 8 7 8.89543 7 10C7 11.1046 7.89543 12 9 12Z"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 8H17"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12H17"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 16H17"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196484">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const CreditIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24160_196499)">
        <path
          d="M12.332 21C17.3026 21 21.332 16.9706 21.332 12C21.332 7.02944 17.3026 3 12.332 3C7.36147 3 3.33203 7.02944 3.33203 12C3.33203 16.9706 7.36147 21 12.332 21Z"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.132 9.00016C14.9509 8.68592 14.6877 8.42686 14.3706 8.25071C14.0535 8.07456 13.6945 7.98795 13.332 8.00016H11.332C10.8016 8.00016 10.2929 8.21087 9.91782 8.58594C9.54275 8.96102 9.33203 9.46972 9.33203 10.0002C9.33203 10.5306 9.54275 11.0393 9.91782 11.4144C10.2929 11.7894 10.8016 12.0002 11.332 12.0002H13.332C13.8625 12.0002 14.3712 12.2109 14.7462 12.5859C15.1213 12.961 15.332 13.4697 15.332 14.0002C15.332 14.5306 15.1213 15.0393 14.7462 15.4144C14.3712 15.7894 13.8625 16.0002 13.332 16.0002H11.332C10.9695 16.0124 10.6105 15.9258 10.2934 15.7496C9.97638 15.5735 9.71318 15.3144 9.53203 15.0002"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.332 6V8M12.332 16V18"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196499">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.332031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UsersIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24160_196518)">
        <path
          d="M9.66797 11C11.8771 11 13.668 9.20914 13.668 7C13.668 4.79086 11.8771 3 9.66797 3C7.45883 3 5.66797 4.79086 5.66797 7C5.66797 9.20914 7.45883 11 9.66797 11Z"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.66797 21V19C3.66797 17.9391 4.0894 16.9217 4.83954 16.1716C5.58969 15.4214 6.6071 15 7.66797 15H11.668C12.7288 15 13.7463 15.4214 14.4964 16.1716C15.2465 16.9217 15.668 17.9391 15.668 19V21"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.668 3.12988C17.5284 3.35018 18.291 3.85058 18.8356 4.55219C19.3802 5.2538 19.6758 6.11671 19.6758 7.00488C19.6758 7.89305 19.3802 8.75596 18.8356 9.45757C18.291 10.1592 17.5284 10.6596 16.668 10.8799"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.668 21.0004V19.0004C21.6629 18.1175 21.3659 17.2612 20.8232 16.5648C20.2806 15.8684 19.5228 15.3711 18.668 15.1504"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196518">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.667969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const OrdersIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24160_196538)">
        <path
          d="M9 6H20"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 12H20"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 18H20"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 6V6.01"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 12V12.01"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 18V18.01"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196538">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LongArrowRight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_24160_196553)">
        <path
          d="M5 12H19"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 16L19 12"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 8L19 12"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196553">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DownloadIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_24160_196799)">
        <path
          d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 11V17"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 14L12 17L15 14"
          stroke="#198000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_24160_196799">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InfoOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <circle cx="8" cy="8" r="7.25" stroke="#9D9C9A" strokeWidth="1.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9135 3.42969H7.19922V5.14397H8.9135V3.42969ZM8.9135 6.28683H7.19922V12.5725H8.9135V6.28683Z"
        fill="#9D9C9A"
      />
    </svg>
  );
};
export const PlusIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 1C9 0.447715 8.55229 0 8 0C7.44772 0 7 0.447715 7 1V6.5H1.5C0.947715 6.5 0.5 6.94772 0.5 7.5C0.5 8.05229 0.947715 8.5 1.5 8.5H7V14C7 14.5523 7.44772 15 8 15C8.55229 15 9 14.5523 9 14V8.5H14.5C15.0523 8.5 15.5 8.05229 15.5 7.5C15.5 6.94772 15.0523 6.5 14.5 6.5H9V1Z"
        fill="#198000"
      />
    </svg>
  );
};
export const MinusIcon = ({ className }) => {
  return (
    <svg
      width="16"
      height="3"
      viewBox="0 0 16 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H14.5C15.0523 0.5 15.5 0.947715 15.5 1.5C15.5 2.05228 15.0523 2.5 14.5 2.5H1.5C0.947715 2.5 0.5 2.05228 0.5 1.5Z"
        fill="#198000"
      />
    </svg>
  );
};
export const ShareLinkIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.34578 22H14.6542C15.6862 22 16.4601 21.7466 16.9761 21.2397C17.492 20.7329 17.75 19.9791 17.75 18.9783V9.25034C17.75 8.2496 17.492 7.49579 16.9761 6.98892C16.4601 6.48206 15.6862 6.22862 14.6542 6.22862H11.9035V7.79797H14.6247C15.111 7.79797 15.4889 7.92793 15.7584 8.18786C16.0279 8.4478 16.1626 8.8312 16.1626 9.33807V18.8906C16.1626 19.3974 16.0279 19.7808 15.7584 20.0408C15.4889 20.3007 15.111 20.4307 14.6247 20.4307H3.36549C2.87254 20.4307 2.4946 20.3007 2.23169 20.0408C1.96878 19.7808 1.83733 19.3974 1.83733 18.8906V9.33807C1.83733 8.8312 1.96878 8.4478 2.23169 8.18786C2.4946 7.92793 2.87254 7.79797 3.36549 7.79797H6.09648V6.22862H3.34578C2.31385 6.22862 1.5399 6.48043 1.02394 6.98405C0.507981 7.48768 0.25 8.2431 0.25 9.25034V18.9783C0.25 19.9855 0.507981 20.7409 1.02394 21.2446C1.5399 21.7482 2.31385 22 3.34578 22ZM8.99506 14.3677C9.21197 14.3677 9.39765 14.293 9.55211 14.1435C9.70657 13.9941 9.7838 13.8154 9.7838 13.6074V3.59682L9.72464 2.13469L10.3852 2.82676L11.8838 4.40585C12.0218 4.56181 12.1993 4.63979 12.4162 4.63979C12.6199 4.63979 12.7908 4.57481 12.9289 4.44484C13.0669 4.31487 13.1359 4.14917 13.1359 3.94772C13.1359 3.76577 13.0571 3.59681 12.8993 3.44086L9.5669 0.263182C9.4683 0.165707 9.37464 0.0974749 9.28591 0.0584848C9.19718 0.0194949 9.10023 0 8.99506 0C8.89647 0 8.80281 0.0194949 8.71408 0.0584848C8.62534 0.0974749 8.52839 0.165707 8.42323 0.263182L5.09084 3.44086C4.93966 3.59681 4.86408 3.76577 4.86408 3.94772C4.86408 4.14917 4.9298 4.31487 5.06126 4.44484C5.19272 4.57481 5.36361 4.63979 5.57394 4.63979C5.79741 4.63979 5.97817 4.56181 6.1162 4.40585L7.60493 2.82676L8.27535 2.13469L8.21619 3.59682V13.6074C8.21619 13.8154 8.29342 13.9941 8.44788 14.1435C8.60234 14.293 8.78473 14.3677 8.99506 14.3677Z"
        fill="#198000"
      />
    </svg>
  );
};
export const CopyLinkIcon = ({ className }) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.29 4.64107L15.7791 4.64107L15.7791 6.25485L18.2701 6.25485C18.7664 6.25485 19.1468 6.38852 19.4115 6.65588C19.6761 6.92317 19.8084 7.31742 19.8084 7.83865L19.8084 17.8024C19.8084 18.3236 19.6761 18.7179 19.4115 18.9852C19.1468 19.2525 18.7664 19.3862 18.2701 19.3862L8.3557 19.3862C7.86607 19.3862 7.48728 19.2525 7.21933 18.9852C6.95137 18.7179 6.8174 18.3236 6.8174 17.8024L6.8174 15.6072L5.21964 15.6072L5.21964 17.8926C5.21964 18.9217 5.47933 19.6969 5.9987 20.2181C6.51808 20.7394 7.29382 21 8.32593 21L18.29 21C19.3287 21 20.1078 20.741 20.6272 20.2231C21.1466 19.7053 21.4063 18.9284 21.4063 17.8926L21.4063 7.74843C21.4063 6.71261 21.1466 5.93576 20.6272 5.41788C20.1078 4.90001 19.3288 4.64107 18.29 4.64107ZM13.4767 -6.93225e-07L3.51264 -1.56431e-06C2.48046 -1.65455e-06 1.70469 0.260613 1.18531 0.781841C0.665939 1.30307 0.40625 2.07824 0.40625 3.10735L0.406249 13.2515C0.406249 14.2807 0.665938 15.0558 1.18531 15.5771C1.70469 16.0983 2.48046 16.3589 3.51264 16.3589L13.4767 16.3589C14.5154 16.3589 15.2945 16.1 15.8139 15.5821C16.3332 15.0642 16.5929 14.2873 16.5929 13.2515L16.5929 3.10735C16.5929 2.07161 16.3332 1.29476 15.8139 0.776813C15.2945 0.258937 14.5154 -6.02415e-07 13.4767 -6.93225e-07Z"
        fill="#198000"
      />
    </svg>
  );
};
export const ImportCsvIcon = ({ className }) => {
  return (
    <svg
      width="74"
      height="34"
      viewBox="0 0 74 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M58.9688 5.76562H15.0312C13.7541 5.76562 12.7188 6.23517 12.7188 6.81438V26.7406C12.7188 27.3198 13.7541 27.7894 15.0312 27.7894H58.9688C60.2459 27.7894 61.2812 27.3198 61.2812 26.7406V6.81438C61.2812 6.23517 60.2459 5.76562 58.9688 5.76562Z"
        stroke="#198000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 5.76562V27.7894"
        stroke="#198000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.2812 16.7812H12.7188"
        stroke="#198000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const InviteOrderIcon = ({ className }) => {
  return (
    <svg
      width="36"
      height="19"
      viewBox="0 0 36 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22.5512 5.88501C22.5512 6.777 22.2867 7.64896 21.7912 8.39062C21.2956 9.13229 20.5913 9.71028 19.7672 10.0516C18.9431 10.393 18.0363 10.4824 17.1614 10.3083C16.2865 10.1343 15.4829 9.70483 14.8522 9.0741C14.2215 8.44336 13.7919 7.63975 13.6179 6.76489C13.4439 5.89004 13.5332 4.98315 13.8745 4.15906C14.2159 3.33496 14.794 2.63057 15.5356 2.13501C16.2773 1.63944 17.1493 1.375 18.0413 1.375C19.2374 1.375 20.3845 1.85013 21.2303 2.69592C22.0761 3.54171 22.5512 4.68888 22.5512 5.88501V5.88501Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.2603 17.6252H10.8203C10.8203 15.7104 11.581 13.8739 12.935 12.5199C14.289 11.1659 16.1255 10.4053 18.0403 10.4053C19.9552 10.4053 21.7916 11.1659 23.1456 12.5199C24.4996 13.8739 25.2603 15.7104 25.2603 17.6252Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2995 7.37489C10.2995 8.0458 10.1004 8.70159 9.7275 9.25929C9.35456 9.81699 8.82453 10.2515 8.20451 10.5078C7.58448 10.7641 6.90235 10.8306 6.24449 10.699C5.58662 10.5674 4.9826 10.2435 4.5089 9.76845C4.03521 9.29335 3.71313 8.6883 3.58346 8.03004C3.45379 7.37179 3.52234 6.68996 3.78045 6.07069C4.03857 5.45143 4.47463 4.92258 5.03343 4.55128C5.59222 4.17999 6.24863 3.9829 6.91953 3.98488C7.36424 3.98488 7.80458 4.07269 8.21531 4.24318C8.62604 4.41366 8.9991 4.66349 9.31309 4.97841C9.62708 5.29333 9.87584 5.66715 10.0451 6.07838C10.2144 6.48962 10.3008 6.93018 10.2995 7.37489V7.37489Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.74 16.1747H1.5C1.50046 14.9702 1.90214 13.8002 2.64163 12.8494C3.38112 11.8986 4.41626 11.2212 5.5836 10.9242C6.75094 10.6272 7.98396 10.7274 9.08794 11.2092C10.1919 11.691 11.1039 12.5269 11.68 13.5847"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8203 7.37489C25.8203 8.04537 26.0191 8.70083 26.3916 9.25832C26.7641 9.8158 27.2936 10.2503 27.913 10.5069C28.5325 10.7634 29.2141 10.8305 29.8717 10.6997C30.5293 10.5689 31.1333 10.2461 31.6074 9.77199C32.0815 9.29789 32.4044 8.69387 32.5352 8.03627C32.666 7.37867 32.5989 6.69697 32.3423 6.07753C32.0857 5.45809 31.6512 4.92867 31.0937 4.55617C30.5362 4.18367 29.8808 3.98488 29.2103 3.98488C28.7648 3.98356 28.3234 4.07035 27.9115 4.24025C27.4996 4.41015 27.1253 4.65981 26.8103 4.97487C26.4952 5.28992 26.2456 5.66417 26.0757 6.07606C25.9058 6.48795 25.819 6.92934 25.8203 7.37489V7.37489Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3892 16.1747H34.6292C34.6288 14.9702 34.2271 13.8002 33.4876 12.8494C32.7481 11.8986 31.7129 11.2212 30.5456 10.9242C29.3783 10.6272 28.1452 10.7274 27.0413 11.2092C25.9373 11.691 25.0253 12.5269 24.4492 13.5847"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SilverIcon = () => {
  return (
    <svg
      width="20"
      height="26"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.5C4.615 0.5 0.25 4.865 0.25 10.25C0.25 12.8429 1.26715 15.1948 2.90955 16.9393C3.09433 17.1356 3.205 17.392 3.205 17.6616V24.5993C3.205 25.2857 3.88062 25.768 4.52977 25.5451L9.34829 23.8905C9.77058 23.7454 10.2293 23.7459 10.6513 23.8918L15.4233 25.5414C16.0728 25.7659 16.75 25.2835 16.75 24.5963V17.6964C16.75 17.424 16.863 17.1651 17.0512 16.9682C18.7198 15.2223 19.75 12.8566 19.75 10.25C19.75 4.865 15.385 0.5 10 0.5ZM14.5 22.4506C14.5 22.8059 14.1398 23.0479 13.8109 22.9135L10.7526 21.6641C10.27 21.467 9.72958 21.466 9.24633 21.6615L6.14248 22.9169C5.81379 23.0499 5.455 22.808 5.455 22.4534V19.704C5.455 19.3276 5.8571 19.0835 6.20371 19.2304C7.37521 19.7268 8.65725 20 10 20C11.3282 20 12.5959 19.7278 13.7535 19.2411C14.0997 19.0956 14.5 19.3396 14.5 19.7152V22.4506ZM10 17.75C5.86 17.75 2.5 14.39 2.5 10.25C2.5 6.11 5.86 2.75 10 2.75C14.14 2.75 17.5 6.11 17.5 10.25C17.5 14.39 14.14 17.75 10 17.75ZM7.67388 13.0354C7.52925 13.4998 8.06569 13.8763 8.45332 13.5825L9.69713 12.6396C9.87612 12.5039 10.1236 12.5042 10.3023 12.6404L11.5371 13.5815C11.9237 13.8762 12.4609 13.5018 12.3182 13.0371L11.8251 11.431C11.7647 11.2344 11.831 11.0208 11.992 10.8928L13.3781 9.79147C13.7488 9.49692 13.5405 8.9 13.067 8.9H11.4584C11.2417 8.9 11.0497 8.76042 10.9828 8.5543L10.4756 6.99088C10.326 6.52995 9.67395 6.52995 9.52441 6.99087L9.01716 8.5543C8.95029 8.76042 8.75826 8.9 8.54156 8.9H6.93297C6.4595 8.9 6.25122 9.49692 6.62191 9.79146L8.00683 10.8919C8.16846 11.0203 8.23454 11.2349 8.17316 11.432L7.67388 13.0354Z"
        fill="white"
      />
    </svg>
  );
};
export const GoldIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4167 2.83333H19.25V0.75H6.75V2.83333H2.58333C1.4375 2.83333 0.5 3.77083 0.5 4.91667V7C0.5 10.4583 3.29167 13.25 6.75 13.25H7.125C7.875 15.3542 9.70833 16.9375 11.9583 17.3125V21.5833H6.75V23.6667H11.9583H14.0417H19.25V21.5833H14.0417V17.3125C16.2917 16.9375 18.125 15.3542 18.875 13.25H19.25C22.7083 13.25 25.5 10.4583 25.5 7V4.91667C25.5 3.77083 24.5625 2.83333 23.4167 2.83333ZM2.58333 7V4.91667H6.75V11.1667C4.45833 11.1667 2.58333 9.29167 2.58333 7ZM13 15.3333C10.7083 15.3333 8.83333 13.4583 8.83333 11.1667V2.83333H17.1667V11.1667C17.1667 13.4583 15.2917 15.3333 13 15.3333ZM23.4167 7C23.4167 9.29167 21.5417 11.1667 19.25 11.1667V4.91667H23.4167V7Z"
        fill="white"
      />
    </svg>
  );
};
export const DiamondIcon = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 0.500305H3L0 8.0003L12 21.5003L24 8.0003L21 0.500305ZM9.315 6.8753L11.385 2.7503H12.615L14.685 6.8753H9.315ZM10.875 9.1253V16.8503L4.005 9.1253H10.875ZM13.125 9.1253H19.995L13.125 16.8503V9.1253ZM21.12 6.8753H17.19L15.135 2.7503H19.485L21.12 6.8753ZM4.53 2.7503H8.88L6.81 6.8753H2.88L4.53 2.7503Z"
        fill="white"
      />
    </svg>
  );
};

export const GoldVisa = () => {
  return (
    <svg
      width="90"
      height="60"
      viewBox="0 0 90 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_14834_133147)">
        <path
          d="M8.59938 2.5H81.4006C82.5674 2.5 83.5 3.42933 83.5 4.55951V47.4405C83.5 48.5707 82.5674 49.5 81.4006 49.5H8.59938C7.43261 49.5 6.5 48.5707 6.5 47.4405V4.55951C6.5 3.42933 7.43261 2.5 8.59938 2.5Z"
          fill="white"
          stroke="#DF854F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.4612 19.1444L54.9223 22.2673C53.318 21.3794 49.638 21.1712 49.638 22.8C49.638 23.4472 50.4645 23.8923 51.4607 24.4288C52.9718 25.2426 54.8733 26.2667 54.8733 28.5252C54.8733 32.1318 51.0096 33.4605 48.4501 33.4605C46.9985 33.4852 45.5576 33.2078 44.2189 32.6461L44.7761 29.407C46.3131 30.6439 50.9667 30.999 50.9667 29.0396C50.9667 28.2157 50.0488 27.7307 48.9848 27.1685C47.5183 26.3935 45.7742 25.472 45.7742 23.3143C45.7742 19.3587 50.2197 18.5321 52.0873 18.5321C53.2372 18.5568 54.3759 18.7635 55.4612 19.1444ZM31.4462 28.7092L35.0222 18.8018H39.039L33.0933 33.2281H29.1806L25.923 20.6939C24.7065 19.9475 23.3828 19.392 21.998 19.0467L22.0654 18.8018H27.9804C28.3863 18.7497 28.7968 18.8553 29.1272 19.0968C29.4575 19.3383 29.6827 19.6973 29.7562 20.0999L31.0237 26.5783L31.4462 28.7092ZM38.1738 33.21H41.9274L44.2726 18.802H40.519L38.1738 33.21ZM64.5263 33.2281H67.9736L64.9733 18.8201H61.9545C61.5894 18.7919 61.2247 18.8805 60.9132 19.0731C60.6017 19.2657 60.3595 19.5524 60.2216 19.8917L54.625 33.2281H58.5377L59.3215 31.0911H64.0915L64.5263 33.2281ZM60.3992 28.1335L62.3709 22.739L63.4792 28.1335H60.3992Z"
          fill="#0066B2"
        />
        <path
          d="M31.0237 26.5783L29.7562 20.1C29.6827 19.6974 29.4575 19.3383 29.1272 19.0968C28.7968 18.8553 28.3864 18.7497 27.9804 18.8018H22.0654L21.998 19.0468C24.0334 19.5643 25.9323 20.5169 27.5641 21.839C29.1158 23.0853 30.3096 24.7206 31.0237 26.5783Z"
          fill="#F9A533"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_14834_133147"
          x="0"
          y="0"
          width="90"
          height="60"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14834_133147"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_14834_133147"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DiamondVisa = () => {
  return (
    <svg
      width="82"
      height="60"
      viewBox="0 0 82 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_14834_133240)">
        <path
          d="M8.30382 2.5H72.8274C73.7754 2.5 74.6312 3.37127 74.6312 4.55951V47.4405C74.6312 48.6287 73.7754 49.5 72.8274 49.5H8.30382C7.3558 49.5 6.5 48.6287 6.5 47.4405V4.55951C6.5 3.37127 7.3558 2.5 8.30382 2.5Z"
          fill="white"
          stroke="#4C86A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.8378 19.1446L49.3602 22.2675C47.9384 21.3796 44.6767 21.1714 44.6767 22.8002C44.6767 23.4473 45.4093 23.8925 46.2922 24.429C47.6315 25.2428 49.3168 26.2669 49.3168 28.5254C49.3168 32.132 45.8924 33.4607 43.6239 33.4607C42.3374 33.4853 41.0603 33.208 39.8738 32.6463L40.3677 29.4071C41.7299 30.644 45.8544 30.9992 45.8544 29.0398C45.8544 28.2159 45.0408 27.7309 44.0979 27.1687C42.798 26.3937 41.2523 25.4722 41.2523 23.3145C41.2523 19.3589 45.1923 18.5323 46.8475 18.5323C47.8667 18.557 48.876 18.7637 49.8378 19.1446ZM28.5536 28.7091L31.7229 18.8017H35.283L30.0134 33.2281H26.5456L23.6584 20.6938C22.5802 19.9474 21.407 19.3919 20.1797 19.0467L20.2394 18.8017H25.4819C25.8416 18.7496 26.2054 18.8552 26.4982 19.0967C26.791 19.3382 26.9906 19.6973 27.0557 20.0998L28.1791 26.5782L28.5536 28.7091ZM34.518 33.2099H37.8447L39.9233 18.8019H36.5965L34.518 33.2099ZM57.8758 33.2282H60.9312L58.272 18.8202H55.5965C55.2728 18.792 54.9496 18.8806 54.6735 19.0732C54.3975 19.2658 54.1828 19.5525 54.0606 19.8918L49.1003 33.2282H52.5682L53.2628 31.0912H57.4905L57.8758 33.2282ZM54.218 28.1337L55.9655 22.7391L56.9478 28.1337H54.218Z"
          fill="#0066B2"
        />
        <path
          d="M28.181 26.5785L27.0577 20.1001C26.9925 19.6976 26.793 19.3385 26.5002 19.097C26.2073 18.8555 25.8436 18.7499 25.4838 18.802H20.2413L20.1816 19.047C21.9855 19.5645 23.6686 20.5171 25.1148 21.8391C26.4901 23.0854 27.5481 24.7208 28.181 26.5785Z"
          fill="#F9A533"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_14834_133240"
          x="0"
          y="0"
          width="81.1309"
          height="60"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_14834_133240"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_14834_133240"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const StatusBadge = () => {
  return (
    <svg
      width="45"
      height="40"
      viewBox="0 0 45 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.3448 19.2895L43.3368 19.2681L43.3269 19.2476C43.0629 18.701 42.489 18.3701 41.8875 18.4133C39.5114 14.0949 34.737 11.5229 29.7689 11.9308C31.1529 10.6381 31.7817 9.32914 32.3336 8.1802C32.4316 7.97618 32.5272 7.77721 32.6241 7.58428L32.9086 7.01825L32.2919 6.87309C29.8828 6.30594 27.8063 6.13168 26.157 6.87927C25.3646 7.23847 24.7013 7.79478 24.155 8.56728C24.1579 8.54053 24.1608 8.51391 24.1636 8.48743C24.2711 7.47519 24.3165 6.61692 24.1979 5.84211C23.9504 4.22546 23.0089 3.09538 20.9553 1.59628L20.4835 1.25184L20.216 1.77119C19.8734 2.43642 19.5347 3.05084 19.2131 3.63423C19.1249 3.79431 19.038 3.95206 18.9526 4.10787C18.559 4.82612 18.1976 5.50504 17.9153 6.15619C17.3488 7.46294 17.0723 8.72216 17.5118 10.0685C17.6369 10.4539 17.7643 10.8224 17.8893 11.1681C17.4593 10.6093 17.0062 9.96632 16.5838 9.26481C15.5431 7.5312 13.9507 6.60234 12.3737 6.08117C10.9103 5.59752 9.42242 5.45362 8.35679 5.35055C8.28055 5.34317 8.20648 5.33601 8.13473 5.32894L7.5116 5.26759L7.58963 5.88885C7.60829 6.03742 7.62639 6.18236 7.64405 6.32385C7.84788 7.95653 7.9943 9.12936 8.28905 10.0974C8.62095 11.1874 9.13738 12.0152 10.0743 12.9919C10.7518 13.7 11.7927 14.2589 12.6469 14.6406C12.3326 14.6658 11.9869 14.6787 11.6197 14.6693C10.0321 14.6287 8.07718 14.1752 6.48343 12.5531L5.90499 11.9644L5.65103 12.7497C5.01788 14.7075 5.65808 17.421 7.68506 18.8654C2.85023 21.5809 0.315319 27.2858 1.88097 32.8605L1.88118 32.8612C2.12292 33.7169 2.45042 34.5278 2.84998 35.287C3.76577 37.3454 5.17711 39.1645 6.79079 40.7416C6.71229 40.9152 6.67288 41.1036 6.66778 41.2833C6.65716 41.6574 6.79074 42.0731 7.12873 42.3747L7.12911 42.3751C8.73431 43.8049 10.4643 45.0269 12.0943 46.0357L12.1008 46.0397L12.1074 46.0435L14.0497 47.165L14.0496 47.1651L14.0583 47.1699C17.6005 49.1223 21.0764 50.4682 23.8601 51.3183C25.2521 51.7433 26.4746 52.0456 27.4495 52.2377C28.4103 52.4271 29.1669 52.517 29.6097 52.4975L29.6708 52.4948L29.7294 52.4774C30.2047 52.3369 30.7534 51.9884 31.3311 51.5181C31.9198 51.0387 32.5791 50.3989 33.278 49.627C34.6763 48.0826 36.2553 45.9848 37.7689 43.5232C40.7923 38.6063 43.5878 32.1847 44.1324 25.7641L44.1326 25.7607C44.1489 25.5518 44.1634 25.3333 44.1611 25.1068C44.2894 23.5561 44.1497 21.9581 43.7053 20.3651L43.7054 20.3651L43.7017 20.3529C43.5934 19.9997 43.4765 19.6409 43.3448 19.2895Z"
        fill="#198000"
        stroke="white"
      />
      <path
        d="M32.1205 21.7122H28.5036V19.9038H17.6529V21.7122H14.036C13.0413 21.7122 12.2275 22.526 12.2275 23.5207V25.3291C12.2275 28.3311 14.6509 30.7545 17.6529 30.7545H17.9784C18.6294 32.581 20.2209 33.9554 22.174 34.2809V37.9883H17.6529V39.7967H22.174H23.9825H28.5036V37.9883H23.9825V34.2809C25.9356 33.9554 27.527 32.581 28.1781 30.7545H28.5036C31.5056 30.7545 33.9289 28.3311 33.9289 25.3291V23.5207C33.9289 22.526 33.1151 21.7122 32.1205 21.7122ZM14.036 25.3291V23.5207H17.6529V28.946C15.6636 28.946 14.036 27.3184 14.036 25.3291ZM23.0782 32.5629C21.0889 32.5629 19.4613 30.9353 19.4613 28.946V21.7122H26.6951V28.946C26.6951 30.9353 25.0675 32.5629 23.0782 32.5629ZM32.1205 25.3291C32.1205 27.3184 30.4929 28.946 28.5036 28.946V23.5207H32.1205V25.3291Z"
        fill="white"
      />
    </svg>
  );
};

export const DiamondBlue = () => {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7996 0.400391H4.19961L0.599609 9.40039L14.9996 25.6004L29.3996 9.40039L25.7996 0.400391ZM11.7776 8.05039L14.2616 3.10039H15.7376L18.2216 8.05039H11.7776ZM13.6496 10.7504V20.0204L5.40561 10.7504H13.6496ZM16.3496 10.7504H24.5936L16.3496 20.0204V10.7504ZM25.9436 8.05039H21.2276L18.7616 3.10039H23.9816L25.9436 8.05039ZM6.03561 3.10039H11.2556L8.77161 8.05039H4.05561L6.03561 3.10039Z"
        fill="#4C86A0"
      />
    </svg>
  );
};

export const DiamondOrange = () => {
  return (
    <svg
      width="25"
      height="22"
      viewBox="0 0 25 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6314 1.96862H18.698V0.00195312H6.89805V1.96862H2.96471C1.88305 1.96862 0.998047 2.85362 0.998047 3.93529V5.90195C0.998047 9.16662 3.63338 11.802 6.89805 11.802H7.25205C7.96005 13.7883 9.69071 15.283 11.8147 15.637V19.6686H6.89805V21.6353H11.8147H13.7814H18.698V19.6686H13.7814V15.637C15.9054 15.283 17.636 13.7883 18.344 11.802H18.698C21.9627 11.802 24.598 9.16662 24.598 5.90195V3.93529C24.598 2.85362 23.713 1.96862 22.6314 1.96862ZM2.96471 5.90195V3.93529H6.89805V9.83529C4.73471 9.83529 2.96471 8.06529 2.96471 5.90195ZM12.798 13.7686C10.6347 13.7686 8.86471 11.9986 8.86471 9.83529V1.96862H16.7314V9.83529C16.7314 11.9986 14.9614 13.7686 12.798 13.7686ZM22.6314 5.90195C22.6314 8.06529 20.8614 9.83529 18.698 9.83529V3.93529H22.6314V5.90195Z"
        fill="#DF854F"
      />
    </svg>
  );
};

export const SilverGrey = () => {
  return (
    <svg
      width="24"
      height="31"
      viewBox="0 0 24 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0008 0.599609C5.53878 0.599609 0.300781 5.83761 0.300781 12.2996C0.300781 15.4415 1.54534 18.2886 3.55026 20.388C3.73643 20.5829 3.84678 20.8396 3.84678 21.1092V29.7989C3.84678 30.4853 4.5224 30.9676 5.17156 30.7447L11.3491 28.6234C11.7714 28.4784 12.23 28.4789 12.652 28.6247L18.7741 30.741C19.4236 30.9655 20.1008 30.4831 20.1008 29.7959V21.15C20.1008 20.8776 20.2135 20.6185 20.4031 20.4229C22.4402 18.3221 23.7008 15.4582 23.7008 12.2996C23.7008 5.83761 18.4628 0.599609 12.0008 0.599609ZM17.4008 27.0892C17.4008 27.4445 17.0406 27.6865 16.7117 27.5521L12.7534 25.9351C12.2708 25.7379 11.7304 25.737 11.2471 25.9324L7.23426 27.5555C6.90558 27.6885 6.54678 27.4466 6.54678 27.092V23.4786C6.54678 23.1022 6.94853 22.8585 7.29304 23.0103C8.7397 23.6477 10.3311 23.9996 12.0008 23.9996C13.6528 23.9996 15.2269 23.6486 16.6567 23.024C17.0008 22.8736 17.4008 23.1172 17.4008 23.4928V27.0892ZM12.0008 21.2996C7.03278 21.2996 3.00078 17.2676 3.00078 12.2996C3.00078 7.33161 7.03278 3.29961 12.0008 3.29961C16.9688 3.29961 21.0008 7.33161 21.0008 12.2996C21.0008 17.2676 16.9688 21.2996 12.0008 21.2996ZM9.11666 15.94C8.97204 16.4044 9.50847 16.7809 9.8961 16.4871L11.6979 15.1212C11.8769 14.9855 12.1244 14.9858 12.3031 15.122L14.0929 16.4862C14.4795 16.7808 15.0166 16.4064 14.874 15.9417L14.1709 13.6516C14.1105 13.455 14.1767 13.2414 14.3378 13.1134L16.2789 11.5711C16.6496 11.2765 16.4413 10.6796 15.9678 10.6796H13.6782C13.4615 10.6796 13.2695 10.54 13.2026 10.3339L12.4764 8.09548C12.3268 7.63456 11.6747 7.63456 11.5252 8.09548L10.7989 10.3339C10.7321 10.54 10.54 10.6796 10.3233 10.6796H8.03375C7.56028 10.6796 7.352 11.2765 7.72269 11.5711L9.66261 13.1125C9.82425 13.241 9.89032 13.4555 9.82894 13.6526L9.11666 15.94Z"
        fill="#9D9C9A"
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
    >
      <circle cx="44" cy="44" r="44" fill="#198000" />
      <g clipPath="url(#clip0_26257_224796)">
        <path
          d="M28 34H60"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40 42V54"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48 42V54"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30 34L32 58C32 59.0609 32.4214 60.0783 33.1716 60.8284C33.9217 61.5786 34.9391 62 36 62H52C53.0609 62 54.0783 61.5786 54.8284 60.8284C55.5786 60.0783 56 59.0609 56 58L58 34"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38 34V28C38 27.4696 38.2107 26.9609 38.5858 26.5858C38.9609 26.2107 39.4696 26 40 26H48C48.5304 26 49.0391 26.2107 49.4142 26.5858C49.7893 26.9609 50 27.4696 50 28V34"
          stroke="white"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_26257_224796">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(20 20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EditPencilIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6605 3.5C17.2189 3.5 16.7818 3.58779 16.3744 3.75835C15.9679 3.92854 15.5992 4.17772 15.2897 4.49132L4.97843 14.8092C4.88348 14.9042 4.81579 15.023 4.78243 15.1531L3.52351 20.0637C3.45769 20.3205 3.53227 20.5929 3.71967 20.7803C3.90708 20.9677 4.17949 21.0423 4.43623 20.9765L9.35091 19.7168C9.4812 19.6834 9.60012 19.6156 9.69519 19.5204L20.0058 9.2033C20.3201 8.89416 20.57 8.52556 20.7407 8.11893C20.9118 7.71112 21 7.27327 21 6.83095C21 6.38863 20.9118 5.95078 20.7407 5.54296C20.5695 5.13512 20.3187 4.76554 20.0029 4.45584C19.9796 4.43297 19.9552 4.41191 19.9298 4.39268C19.6423 4.12517 19.3095 3.91028 18.9466 3.75835C18.5393 3.58779 18.1021 3.5 17.6605 3.5ZM18.9648 5.5461C18.983 5.56454 19.0019 5.58185 19.0214 5.59802C19.1626 5.75242 19.2764 5.93014 19.3576 6.12354C19.4516 6.34752 19.5 6.588 19.5 6.83095C19.5 7.0739 19.4516 7.31438 19.3576 7.53836C19.2636 7.76231 19.1258 7.96524 18.9525 8.13526L18.9525 8.13523L18.9472 8.1405L18.5636 8.52439L17.5318 7.49256L15.9792 5.92337L16.3525 5.54989L16.3525 5.54991L16.3562 5.5461C16.5267 5.37306 16.7298 5.2357 16.9536 5.14198C17.1775 5.04826 17.4178 5 17.6605 5C17.9032 5 18.1435 5.04826 18.3674 5.14198C18.5913 5.23572 18.7944 5.37309 18.9648 5.5461ZM14.9189 6.98438L6.18448 15.7244L5.29117 19.2089L8.77944 18.3148L17.5033 9.58539L16.4697 8.55181L16.4669 8.54898L16.4669 8.54897L14.9189 6.98438Z"
        fill="#198000"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.72613 16.7687C13.6156 16.7687 16.7687 13.6156 16.7687 9.72613C16.7687 5.83664 13.6156 2.68359 9.72613 2.68359C5.83664 2.68359 2.68359 5.83664 2.68359 9.72613C2.68359 13.6156 5.83664 16.7687 9.72613 16.7687Z"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.707 14.7051L18.7817 18.7797"
        stroke="#3D3935"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CountDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M23.25 12.0986C23.25 18.3676 18.2079 23.4399 12 23.4399C5.79215 23.4399 0.75 18.3676 0.75 12.0986C0.75 5.8296 5.79215 0.757294 12 0.757294C18.2079 0.757294 23.25 5.8296 23.25 12.0986Z"
        stroke="#198000"
        strokeWidth="1.5"
      />
      <path
        d="M12 7.26289V13.3085H16.8"
        stroke="#198000"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CurrentLocationIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 16.963V14C8.25 13.5858 8.58579 13.25 9 13.25C9.41421 13.25 9.75 13.5858 9.75 14V16.963C13.2933 16.6112 16.1112 13.7933 16.463 10.25H13.5C13.0858 10.25 12.75 9.91421 12.75 9.5C12.75 9.08579 13.0858 8.75 13.5 8.75H16.463C16.1112 5.20669 13.2933 2.38883 9.75 2.03703V5C9.75 5.41421 9.41421 5.75 9 5.75C8.58579 5.75 8.25 5.41421 8.25 5V2.03703C4.70669 2.38883 1.88883 5.20669 1.53703 8.75H4.5C4.91421 8.75 5.25 9.08579 5.25 9.5C5.25 9.91421 4.91421 10.25 4.5 10.25H1.53703C1.88883 13.7933 4.70669 16.6112 8.25 16.963ZM18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM10.5 9.5C10.5 10.3284 9.82843 11 9 11C8.17157 11 7.5 10.3284 7.5 9.5C7.5 8.67157 8.17157 8 9 8C9.82843 8 10.5 8.67157 10.5 9.5ZM12 9.5C12 11.1569 10.6569 12.5 9 12.5C7.34315 12.5 6 11.1569 6 9.5C6 7.84315 7.34315 6.5 9 6.5C10.6569 6.5 12 7.84315 12 9.5Z"
        fill="#198000"
      />
    </svg>
  );
};

export const AddPlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <circle cx="12" cy="12.125" r="12" fill="#198000" />
      <path
        d="M7 12.125H17"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 7.125V17.125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const FabIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66669 10H33.3334"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66669 20H33.3334"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66669 30H33.3334"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FabCloseIcon = () => {
  return (
    <svg
      width="22"
      height="25"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.782715 1.36621L21.2173 23.3903M21.2173 1.36621L0.782715 23.3903"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <circle cx="6.5" cy="6.5" r="6.5" fill="#198000" />
      <path
        d="M8.41933 9.69907C8.36104 9.6979 8.30368 9.68418 8.25116 9.65885L6.48172 8.7266L4.71228 9.65885C4.65416 9.68661 4.58975 9.69852 4.52555 9.69339C4.46135 9.68825 4.39965 9.66625 4.34669 9.62961C4.28997 9.58897 4.24606 9.53296 4.22015 9.46818C4.19424 9.4034 4.1874 9.33256 4.20045 9.26402L4.53679 7.2935L3.10735 5.90061C3.06035 5.85372 3.02702 5.79491 3.01092 5.7305C2.99481 5.66609 2.99655 5.59852 3.01595 5.53502C3.03686 5.47055 3.07529 5.41315 3.12693 5.36925C3.17858 5.32535 3.24142 5.29668 3.30842 5.28642L5.28625 5.00127L6.17097 3.20623C6.20091 3.14442 6.24765 3.09229 6.30584 3.05582C6.36403 3.01934 6.43132 3 6.5 3C6.56868 3 6.63597 3.01934 6.69416 3.05582C6.75235 3.09229 6.79909 3.14442 6.82903 3.20623L7.71375 5.00127L9.69158 5.28642C9.75858 5.29668 9.82142 5.32535 9.87307 5.36925C9.92471 5.41315 9.96314 5.47055 9.98405 5.53502C10.0034 5.59852 10.0052 5.66609 9.98908 5.7305C9.97298 5.79491 9.93965 5.85372 9.89265 5.90061L8.4632 7.2935L8.79955 9.26402C8.8126 9.33256 8.80576 9.4034 8.77985 9.46818C8.75394 9.53296 8.71003 9.58897 8.65331 9.62961C8.58558 9.67888 8.50298 9.7034 8.41933 9.69907Z"
        fill="white"
      />
    </svg>
  );
};

export const VideoPlayIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="white" />
      <g clipPath="url(#clip0_7231_104608)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7558 13.6773C15.0532 13.2997 14.1936 13.7966 14.1936 14.5804V25.4193C14.1936 26.2262 15.099 26.72 15.8015 26.2965L25.3058 20.5652C25.9932 20.1507 25.968 19.1654 25.2601 18.785L15.7558 13.6773Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_7231_104608">
          <rect
            width="12.9032"
            height="12.9032"
            fill="white"
            transform="translate(13.5483 13.5483)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChevronIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.35303 9L12.353 15L18.353 9"
        stroke="#3D3935"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_7565_158)">
        <path
          d="M7.33331 16H26"
          stroke="#3D3935"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6666 21.3333L26 16"
          stroke="#3D3935"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6666 10.6667L26 16.0001"
          stroke="#3D3935"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7565_158">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.666626)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clipPath="url(#clip0_4821_11192)">
        <path
          d="M18 14H30M18 22H30M26 30H30M10 42V10C10 8.93913 10.4214 7.92172 11.1716 7.17157C11.9217 6.42143 12.9391 6 14 6H34C35.0609 6 36.0783 6.42143 36.8284 7.17157C37.5786 7.92172 38 8.93913 38 10V42L32 38L28 42L24 38L20 42L16 38L10 42Z"
          stroke="#3D3935"
          strokeWidth="2.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4821_11192">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RewardFaqIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 7H15M9 11H15M9 15H13M5 5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5Z"
        stroke="#3D3935"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LoyaltyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_7735_1923)">
        <path
          d="M6 9C6 10.5913 6.63214 12.1174 7.75736 13.2426C8.88258 14.3679 10.4087 15 12 15C13.5913 15 15.1174 14.3679 16.2426 13.2426C17.3679 12.1174 18 10.5913 18 9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9Z"
          stroke="#3D3935"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15L15.4 20.89L16.998 17.657L20.596 17.889L17.196 12"
          stroke="#3D3935"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.8021 12L3.4021 17.89L7.0001 17.657L8.5981 20.889L11.9981 15"
          stroke="#3D3935"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7735_1923">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GeoLocationWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_8379_2229)">
        <path
          d="M17.657 16.6572L13.414 20.9002C13.039 21.2748 12.25 22.0002 12 22.0002C11.75 22.0002 10.962 21.2748 10.587 20.9002L6.343 16.6572C5.22422 15.5384 4.46234 14.1129 4.15369 12.5611C3.84504 11.0092 4.00349 9.40071 4.60901 7.93893C5.21452 6.47714 6.2399 5.22774 7.55548 4.3487C8.87107 3.46967 10.4178 3.00049 12 3.00049C13.5822 3.00049 15.1289 3.46967 16.4445 4.3487C17.7601 5.22774 18.7855 6.47714 19.391 7.93893C19.9965 9.40071 20.155 11.0092 19.8463 12.5611C19.5377 14.1129 18.7758 15.5384 17.657 16.6572Z"
          fill="white"
        />
        <path
          d="M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
          fill="#198000"
        />
      </g>
      <defs>
        <clipPath id="clip0_8379_2229">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeliveryIconMobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19C7.53043 19 8.03914 18.7893 8.41421 18.4142C8.78929 18.0391 9 17.5304 9 17M5 17C5 16.4696 5.21071 15.9609 5.58579 15.5858C5.96086 15.2107 6.46957 15 7 15C7.53043 15 8.03914 15.2107 8.41421 15.5858C8.78929 15.9609 9 16.4696 9 17M5 17H3V11M9 17H15M15 17C15 17.5304 15.2107 18.0391 15.5858 18.4142C15.9609 18.7893 16.4696 19 17 19C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17M15 17C15 16.4696 15.2107 15.9609 15.5858 15.5858C15.9609 15.2107 16.4696 15 17 15C17.5304 15 18.0391 15.2107 18.4142 15.5858C18.7893 15.9609 19 16.4696 19 17M19 17H21V13C21 12.4696 20.7893 11.9609 20.4142 11.5858C20.0391 11.2107 19.5304 11 19 11H18M3 11L5 6H14L18 11M3 11H18M12 11V6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.625 11.25L21 16.875H19.125C19.125 16.5 18.375 15 16.875 15C15.675 15 15.125 16.25 15 16.875H9C9 16.125 8.25 15 6.75 15C5.55 15 5 16.25 4.875 16.875H3V10.875H9H13.125L20.625 11.25Z"
        fill="white"
      />
    </svg>
  );
};

export const CartBagItemAdded = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 8V4.88889C9.5 3.85749 9.97411 2.86834 10.818 2.13903C11.6619 1.40972 12.8065 1 14 1C15.1935 1 16.3381 1.40972 17.182 2.13903C18.0259 2.86834 18.5 3.85749 18.5 4.88889V8"
        stroke="#4C86A0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect y="8" width="28" height="22" rx="2" fill="#4C86A0" />
    </svg>
  );
};

export const CartBagIcon = () => {
  return (
    <svg
      width="36"
      height="34"
      viewBox="0 0 36 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.6089 7.95654H3.00019C2.23179 7.95654 1.60889 8.57945 1.60889 9.34785V31.6087C1.60889 32.3771 2.23179 33 3.00019 33H33.6089C34.3773 33 35.0002 32.3771 35.0002 31.6087V9.34785C35.0002 8.57945 34.3773 7.95654 33.6089 7.95654Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3481 13.5217V7.95652C11.3481 6.11154 12.0811 4.34212 13.3857 3.03752C14.6903 1.73292 16.4597 1 18.3047 1C20.1496 1 21.9191 1.73292 23.2237 3.03752C24.5283 4.34212 25.2612 6.11154 25.2612 7.95652V13.5217"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserCircleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path
        d="M16.6086 28.5C9.98122 28.5 4.60864 23.1274 4.60864 16.5C4.60864 9.87258 9.98123 4.5 16.6086 4.5C23.2361 4.5 28.6086 9.87258 28.6086 16.5C28.6086 23.1274 23.2361 28.5 16.6086 28.5Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.6086 20.5C13.8472 20.5 11.6086 18.2614 11.6086 15.5C11.6086 12.7386 13.8472 10.5 16.6086 10.5C19.3701 10.5 21.6086 12.7386 21.6086 15.5C21.6086 18.2614 19.3701 20.5 16.6086 20.5Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.6335 25.4218C23.8803 23.9408 22.7319 22.6971 21.3155 21.8284C19.8991 20.9598 18.27 20.5 16.6084 20.5C14.9469 20.5 13.3178 20.9598 11.9014 21.8284C10.485 22.6971 9.33659 23.9407 8.58333 25.4217"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationOutlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="27"
      viewBox="0 0 24 32"
      fill="none"
    >
      <path
        d="M8.60856 11.6668C8.60856 12.7276 9.02999 13.745 9.78013 14.4952C10.5303 15.2453 11.5477 15.6668 12.6086 15.6668C13.6694 15.6668 14.6868 15.2453 15.437 14.4952C16.1871 13.745 16.6086 12.7276 16.6086 11.6668C16.6086 10.6059 16.1871 9.58849 15.437 8.83834C14.6868 8.08819 13.6694 7.66677 12.6086 7.66677C11.5477 7.66677 10.5303 8.08819 9.78013 8.83834C9.02999 9.58849 8.60856 10.6059 8.60856 11.6668Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1512 19.2094L14.4939 24.8668C13.9939 25.3663 13.316 25.6469 12.6092 25.6469C11.9025 25.6469 11.2246 25.3663 10.7246 24.8668L5.0659 19.2094C3.57419 17.7176 2.55835 15.817 2.14682 13.7479C1.73528 11.6788 1.94655 9.53412 2.7539 7.58507C3.56125 5.63602 4.92843 3.97015 6.68254 2.79811C8.43665 1.62606 10.4989 1.00049 12.6086 1.00049C14.7182 1.00049 16.7805 1.62606 18.5346 2.79811C20.2887 3.97015 21.6559 5.63602 22.4632 7.58507C23.2706 9.53412 23.4818 11.6788 23.0703 13.7479C22.6588 15.817 21.6429 17.7176 20.1512 19.2094Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserCircleFilledIcon = () => {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.10889" y="1" width="31" height="31" rx="15.5" fill="#198000" />
      <rect x="1.10889" y="1" width="31" height="31" rx="15.5" stroke="white" />
      <path
        d="M16.6132 10.5005C12.6368 10.5005 9.41357 13.3342 9.41357 16.8302C9.41357 17.0077 9.42224 17.1836 9.43891 17.3576H23.7882C23.8049 17.1836 23.8136 17.0077 23.8136 16.8302C23.8129 13.3342 20.5897 10.5005 16.6132 10.5005Z"
        fill="white"
        stroke="#198000"
        strokeMiterlimit="10"
      />
      <path
        d="M25.5401 19.9291H7.68706C7.50456 19.9291 7.35645 19.7755 7.35645 19.5863V18.5577C7.35645 18.3684 7.50456 18.2148 7.68706 18.2148H25.5401C25.7226 18.2148 25.8707 18.3684 25.8707 18.5577V19.5863C25.8707 19.7755 25.7226 19.9291 25.5401 19.9291Z"
        fill="white"
        stroke="white"
        strokeMiterlimit="10"
      />
      <rect
        x="14.7704"
        y="9.8576"
        width="3.68571"
        height="0.428571"
        fill="white"
        stroke="white"
        strokeWidth="0.428571"
      />
    </svg>
  );
};

export const LocationFilledIcon = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7284_129)">
        <path
          d="M24.1512 22.2094L18.4939 27.8668C17.9939 28.3663 16.9419 29.3335 16.6086 29.3335C16.2752 29.3335 15.2246 28.3663 14.7246 27.8668L9.0659 22.2094C7.57419 20.7177 6.55835 18.817 6.14682 16.7479C5.73528 14.6788 5.94655 12.5341 6.7539 10.5851C7.56125 8.63603 8.92843 6.97015 10.6825 5.79811C12.4367 4.62606 14.4989 4.00049 16.6086 4.00049C18.7182 4.00049 20.7805 4.62606 22.5346 5.79811C24.2887 6.97015 25.6559 8.63603 26.4632 10.5851C27.2706 12.5341 27.4818 14.6788 27.0703 16.7479C26.6588 18.817 25.6429 20.7177 24.1512 22.2094Z"
          fill="#198000"
        ></path>
        <path
          d="M16.6086 18.6667C18.8178 18.6667 20.6086 16.8759 20.6086 14.6667C20.6086 12.4576 18.8178 10.6667 16.6086 10.6667C14.3995 10.6667 12.6086 12.4576 12.6086 14.6667C12.6086 16.8759 14.3995 18.6667 16.6086 18.6667Z"
          fill="white"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_7284_129">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.608643)"
          ></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeliveryIconLocation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <g clipPath="url(#clip0_7303_111050)">
        <path
          d="M7.27539 22.6667C7.27539 23.3739 7.55634 24.0522 8.05644 24.5523C8.55654 25.0524 9.23481 25.3333 9.94206 25.3333C10.6493 25.3333 11.3276 25.0524 11.8277 24.5523C12.3278 24.0522 12.6087 23.3739 12.6087 22.6667C12.6087 21.9594 12.3278 21.2811 11.8277 20.781C11.3276 20.281 10.6493 20 9.94206 20C9.23481 20 8.55654 20.281 8.05644 20.781C7.55634 21.2811 7.27539 21.9594 7.27539 22.6667Z"
          stroke="#198000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6089 22.6667C20.6089 23.3739 20.8898 24.0522 21.3899 24.5523C21.89 25.0524 22.5683 25.3333 23.2756 25.3333C23.9828 25.3333 24.6611 25.0524 25.1612 24.5523C25.6613 24.0522 25.9422 23.3739 25.9422 22.6667C25.9422 21.9594 25.6613 21.2811 25.1612 20.781C24.6611 20.281 23.9828 20 23.2756 20C22.5683 20 21.89 20.281 21.3899 20.781C20.8898 21.2811 20.6089 21.9594 20.6089 22.6667Z"
          stroke="#198000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.27555 22.6667H4.60889V8.00008C4.60889 7.64646 4.74936 7.30732 4.99941 7.05727C5.24946 6.80722 5.5886 6.66675 5.94222 6.66675H17.9422V22.6667M12.6089 22.6667H20.6089M25.9422 22.6667H28.6089V14.6667M28.6089 14.6667H17.9422M28.6089 14.6667L24.6089 8.00008H17.9422"
          stroke="#198000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.6089 14.5V22.5H26.1089C26.1089 22 25.1089 20 23.1089 20C21.5089 20 20.7756 21.6667 20.6089 22.5H12.6089C12.6089 21.5 11.6089 20 9.60889 20C8.00889 20 7.27555 21.6667 7.10889 22.5H4.60889V6.5H18.1089V14.5H28.6089Z"
          fill="#198000"
        />
      </g>
      <defs>
        <clipPath id="clip0_7303_111050">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.608887)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CartFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="34"
      viewBox="0 0 36 34"
      fill="none"
    >
      <path
        d="M33.6089 7.95654H3.00019C2.23179 7.95654 1.60889 8.57945 1.60889 9.34785V31.6087C1.60889 32.3771 2.23179 33 3.00019 33H33.6089C34.3773 33 35.0002 32.3771 35.0002 31.6087V9.34785C35.0002 8.57945 34.3773 7.95654 33.6089 7.95654Z"
        fill="#198000"
        stroke="#198000"
        stroke-width="1.55882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3481 13.5217V7.95652C11.3481 6.11154 12.0811 4.34212 13.3857 3.03752C14.6903 1.73292 16.4597 1 18.3047 1C20.1496 1 21.9191 1.73292 23.2237 3.03752C24.5283 4.34212 25.2612 6.11154 25.2612 7.95652V13.5217"
        stroke="#198000"
        stroke-width="1.55882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CartOutlineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="34"
      viewBox="0 0 36 34"
      fill="none"
    >
      <path
        d="M33.6089 7.95654H3.00019C2.23179 7.95654 1.60889 8.57945 1.60889 9.34785V31.6087C1.60889 32.3771 2.23179 33 3.00019 33H33.6089C34.3773 33 35.0002 32.3771 35.0002 31.6087V9.34785C35.0002 8.57945 34.3773 7.95654 33.6089 7.95654Z"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3481 13.5217V7.95652C11.3481 6.11154 12.0811 4.34212 13.3857 3.03752C14.6903 1.73292 16.4597 1 18.3047 1C20.1496 1 21.9191 1.73292 23.2237 3.03752C24.5283 4.34212 25.2612 6.11154 25.2612 7.95652V13.5217"
        stroke="#3D3935"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-2 h-2"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 4.5v15m7.5-7.5h-15"
      />
    </svg>
  );
};

export const SeeLessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-2 h-2"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
    </svg>
  );
};

export const CateringDirectionIcon = () => {
  return (
    <svg
      width="53"
      height="18"
      viewBox="0 0 53 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.842 8.7481L18.9534 9.20677L18.9665 9.23213L18.981 9.2567L19.842 8.7481ZM25.8344 1.60665L25.6258 2.58466L25.8344 1.60665ZM0.507877 8.06703C0.0271297 8.33888 -0.142224 8.94897 0.129619 9.42972L4.55956 17.264C4.83141 17.7447 5.44151 17.9141 5.92225 17.6422C6.403 17.3704 6.57235 16.7603 6.30051 16.2795L2.36278 9.31576L9.32657 5.37804C9.80732 5.10619 9.97667 4.4961 9.70483 4.01535C9.43298 3.5346 8.82289 3.36525 8.34214 3.63709L0.507877 8.06703ZM52.6523 10.0232C48.8761 10.1748 45.2416 10.66 41.8613 11.158C38.4608 11.659 35.3529 12.1669 32.5431 12.3876C26.8976 12.8312 22.9667 12.0716 20.703 8.23949L18.981 9.2567C21.8765 14.1585 26.9302 14.8348 32.6998 14.3815C35.5976 14.1538 38.8049 13.6299 42.1528 13.1367C45.5209 12.6404 49.0681 12.1687 52.7325 12.0216L52.6523 10.0232ZM20.7306 8.28942C20.1093 7.08573 20.0093 6.15048 20.1467 5.44548C20.2839 4.74146 20.6801 4.15094 21.2651 3.67483C22.484 2.68273 24.37 2.3168 25.6258 2.58466L26.043 0.628651C24.2171 0.2392 21.7086 0.735156 20.0026 2.12368C19.1251 2.83788 18.4263 3.81737 18.1836 5.06297C17.9411 6.3076 18.1764 7.70162 18.9534 9.20677L20.7306 8.28942ZM25.6258 2.58466C26.7851 2.83191 27.4041 3.60611 27.4934 4.49693C27.5854 5.41506 27.1286 6.70047 25.5768 7.8637C22.4501 10.2075 15.0854 11.8095 1.26756 7.97394L0.732624 9.90107C14.719 13.7834 22.8818 12.3834 26.7764 9.46401C28.7353 7.99563 29.6625 6.08415 29.4834 4.29743C29.3016 2.4834 27.9942 1.0448 26.043 0.628651L25.6258 2.58466Z"
        fill="white"
      />
    </svg>
  );
};

export const TiktokIcon = () => {
  return (
    <svg
      width="40"
      height="43"
      viewBox="0 0 44 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3816 48.8439H14.8043C14.1732 48.7387 13.5157 48.6598 12.8845 48.502C3.62728 46.3981 -1.44841 36.7727 1.91785 27.9888C4.44255 21.4404 11.254 17.4167 18.1706 18.3634C18.5914 18.416 18.7229 18.5738 18.6966 18.9946C18.6703 20.7829 18.644 22.545 18.644 24.3333C18.644 25.3589 18.644 26.3846 18.644 27.4892C18.3547 27.4103 18.1443 27.3577 17.9339 27.3314C13.0949 26.2005 8.65038 30.1717 9.46564 35.2473C9.88643 37.9298 12.0692 40.2704 14.7517 40.8227C17.5131 41.4013 20.1956 40.4282 21.8787 38.1139C22.4836 37.2987 23.0096 36.4308 23.0359 35.3525C23.0622 33.8535 23.1411 32.3282 23.1411 30.8291C23.1411 22.2557 23.1411 13.6822 23.1674 5.10877C23.1674 3.55714 23.1674 2.0318 23.1937 0.480163C23.1937 0.348668 23.1937 0.217174 23.22 0.0330811H31.1097C31.136 0.374967 31.1623 0.716853 31.2149 1.03244C31.5304 3.50454 32.3457 5.79255 33.9762 7.71237C36.422 10.579 39.7094 11.7098 43.3124 12.1043V20.3096C39.0256 20.2044 35.0808 18.942 31.4778 16.4436C31.4778 16.7329 31.4778 16.8907 31.4778 17.0485C31.4778 21.7823 31.4778 26.5161 31.4778 31.2499C31.4778 32.6701 31.4778 34.0902 31.3201 35.484C30.6363 41.6117 25.9551 46.8978 19.9589 48.3705C19.1173 48.5809 18.2495 48.6861 17.4079 48.8439H17.3816Z"
        fill="#F3F1E9"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 51 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3276 49.8493C12.3822 49.7441 9.56817 49.1392 7.06978 47.4824C3.9139 45.3785 2.04668 42.3804 1.4944 38.6985C1.15252 36.4105 1.04732 34.0699 0.994723 31.7556C0.942125 27.4163 0.968424 23.077 0.994723 18.7639C0.994723 16.134 0.994723 13.5042 1.67849 10.9269C3.07234 5.32519 7.30647 1.45924 13.0396 0.906967C16.5374 0.565081 20.0614 0.538782 23.5855 0.512483C27.7407 0.486184 31.896 0.565081 36.0512 0.643977C38.6811 0.696575 41.2321 1.22255 43.5727 2.5375C47.1756 4.58882 49.2796 7.77099 49.9633 11.821C50.2789 13.6356 50.4104 15.4766 50.4104 17.2912C50.463 22.6036 50.463 27.8897 50.4104 33.2021C50.4104 35.4901 50.3052 37.7781 49.674 39.9872C48.1224 45.3522 44.5195 48.4817 39.1019 49.5074C36.0775 50.086 32.9742 49.9545 29.8972 50.0071C28.5034 50.0071 18.7991 49.9808 15.3276 49.8493ZM25.742 4.957C24.1904 4.957 22.6387 4.9044 21.1134 4.957C18.4309 5.0622 15.7221 5.0622 13.0922 5.43038C9.59447 5.93006 7.17497 7.98138 6.22821 11.4265C5.80743 12.8993 5.64963 14.4772 5.59704 16.0026C5.49184 21.1834 5.46554 26.3643 5.49184 31.5452C5.49184 33.6754 5.59704 35.8582 5.93892 37.9622C6.4912 41.381 8.46362 43.8005 11.8825 44.7473C13.3552 45.1681 14.9332 45.3522 16.4585 45.4048C21.2449 45.5099 26.005 45.5625 30.7914 45.51C33.3687 45.51 35.946 45.4311 38.4707 45.0366C42.1262 44.4843 44.5457 42.2752 45.4399 38.6196C45.7818 37.2521 45.9133 35.8056 45.9396 34.3855C46.0185 29.2309 46.0448 24.1026 46.0448 18.948C46.0448 17.0282 45.9396 15.1084 45.7292 13.2149C45.4662 10.8743 44.5457 8.82294 42.7048 7.27131C40.9954 5.85117 38.9704 5.24629 36.8139 5.16739C33.1583 5.0096 29.5028 5.0359 25.8209 4.9307L25.742 4.957Z"
        fill="#F3F1E9"
      />
      <path
        d="M38.4462 25.2335C38.4462 32.229 32.8182 37.9096 25.7701 37.9622C18.7746 38.0148 13.0414 32.3079 13.0151 25.2598C13.0151 18.238 18.722 12.5048 25.7438 12.5311C32.7656 12.5311 38.4199 18.2117 38.4462 25.2335ZM17.486 25.2335C17.486 29.8095 21.1415 33.4913 25.7175 33.5176C30.2672 33.5176 33.9491 29.8621 33.9754 25.3387C33.9754 20.7627 30.3198 17.0545 25.7701 17.0282C21.1941 17.0282 17.486 20.6838 17.486 25.2598V25.2335Z"
        fill="#F3F1E9"
      />
      <path
        d="M41.8894 12.0313C41.8894 13.6881 40.5481 15.0294 38.9176 15.0294C37.3133 15.0294 35.9721 13.6881 35.9458 12.0576C35.9458 10.4271 37.287 9.08582 38.9439 9.08582C40.5744 9.08582 41.8894 10.4008 41.8894 12.0313Z"
        fill="#F3F1E9"
      />
    </svg>
  );
};

export const MailIcon = () => {
  return (
    <svg
      width="45"
      height="41"
      viewBox="0 0 57 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M43.6773 1.03106L4.10482 10.1543C1.28696 10.8039 -0.468227 13.6378 0.186994 16.4798L6.99084 45.9919C7.64606 48.834 10.4648 50.6133 13.2826 49.9637L52.8348 40.8452C55.6526 40.1955 57.4078 37.3617 56.7526 34.5196L49.9487 5.00754C49.2935 2.16548 46.4748 0.386129 43.6569 1.03577L43.6773 1.03106ZM4.91197 13.6554L44.4641 4.53685C45.3625 4.32972 46.2686 4.90166 46.4775 5.80782L46.7244 6.87874L29.9782 26.3991C29.3475 27.0217 28.3987 27.197 27.6062 26.8375L3.84819 16.5033L3.66302 15.7001C3.45411 14.794 4.01827 13.8831 4.91672 13.676L4.91197 13.6554ZM52.0528 37.36L12.4802 46.4832C11.5818 46.6903 10.6758 46.1184 10.4669 45.2122L4.85001 20.8488L26.2195 30.1503C27.3658 30.6452 28.6152 30.7475 29.7791 30.4792C30.943 30.2109 31.8158 29.706 32.597 28.8969L32.6378 28.8875C32.633 28.8669 47.7513 11.2401 47.7513 11.2401L53.3065 35.3358C53.5154 36.242 52.9512 37.1528 52.0528 37.36Z"
        fill="#F3F1E9"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_400_599"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25"
      >
        <ellipse
          cx="12.3381"
          cy="12.1982"
          rx="12.3381"
          ry="12.1982"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_400_599)">
        <path
          d="M19.9871 22.5667C19.9871 25.7452 16.8954 28.5257 12.8083 28.5257C8.72115 28.5257 5.62939 25.7452 5.62939 22.5667C5.62939 19.3882 8.72115 16.6077 12.8083 16.6077C16.8954 16.6077 19.9871 19.3882 19.9871 22.5667Z"
          stroke="#3D3935"
          stroke-width="1.5"
        />
        <path
          d="M19.9871 22.5667C19.9871 25.7452 16.8954 28.5257 12.8083 28.5257C8.72115 28.5257 5.62939 25.7452 5.62939 22.5667C5.62939 19.3882 8.72115 16.6077 12.8083 16.6077C16.8954 16.6077 19.9871 19.3882 19.9871 22.5667Z"
          stroke="#3D3935"
          stroke-opacity="0.5"
          stroke-width="1.5"
        />
      </g>
      <circle
        cx="12.7593"
        cy="13.418"
        r="11.4482"
        stroke="#3D3935"
        stroke-width="1.5"
      />
      <circle
        cx="12.7593"
        cy="13.418"
        r="11.4482"
        stroke="#3D3935"
        stroke-opacity="0.5"
        stroke-width="1.5"
      />
      <circle
        cx="12.7592"
        cy="12.1981"
        r="4.1293"
        stroke="#3D3935"
        stroke-width="1.5"
      />
      <circle
        cx="12.7592"
        cy="12.1981"
        r="4.1293"
        stroke="#3D3935"
        stroke-opacity="0.5"
        stroke-width="1.5"
      />
    </svg>
  );
};

export const PdfIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V11C19 11.5523 19.4477 12 20 12C20.5523 12 21 11.5523 21 11V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM10.3078 23.5628C10.4657 23.7575 10.6952 23.9172 10.9846 23.9762C11.2556 24.0316 11.4923 23.981 11.6563 23.9212C11.9581 23.8111 12.1956 23.6035 12.3505 23.4506C12.5941 23.2105 12.8491 22.8848 13.1029 22.5169C14.2122 22.1342 15.7711 21.782 17.287 21.5602C18.1297 21.4368 18.9165 21.3603 19.5789 21.3343C19.8413 21.6432 20.08 21.9094 20.2788 22.1105C20.4032 22.2363 20.5415 22.3671 20.6768 22.4671C20.7378 22.5122 20.8519 22.592 20.999 22.6493C21.0755 22.6791 21.5781 22.871 22.0424 22.4969C22.3156 22.2768 22.5685 22.0304 22.7444 21.7525C22.9212 21.4733 23.0879 21.0471 22.9491 20.5625C22.8131 20.0881 22.4588 19.8221 22.198 19.6848C21.9319 19.5448 21.6329 19.4668 21.3586 19.4187C21.11 19.3751 20.8288 19.3478 20.5233 19.3344C19.9042 18.5615 19.1805 17.6002 18.493 16.6198C17.89 15.76 17.3278 14.904 16.891 14.1587C16.9359 13.9664 16.9734 13.7816 17.0025 13.606C17.0523 13.3052 17.0824 13.004 17.0758 12.7211C17.0695 12.4497 17.0284 12.1229 16.88 11.8177C16.7154 11.4795 16.416 11.1716 15.9682 11.051C15.5664 10.9428 15.1833 11.0239 14.8894 11.1326C14.4359 11.3004 14.1873 11.6726 14.1014 12.0361C14.0288 12.3437 14.0681 12.6407 14.1136 12.8529C14.2076 13.2915 14.4269 13.7956 14.6795 14.2893C14.702 14.3332 14.7251 14.3777 14.7487 14.4225C14.5103 15.2072 14.1578 16.1328 13.7392 17.0899C13.1256 18.4929 12.4055 19.8836 11.7853 20.878C11.3619 21.0554 10.9712 21.2584 10.6746 21.4916C10.4726 21.6505 10.2019 21.909 10.0724 22.2868C9.9132 22.7514 10.0261 23.2154 10.3078 23.5628ZM11.8757 23.0947C11.8755 23.0946 11.8775 23.0923 11.8824 23.0877C11.8783 23.0924 11.8759 23.0947 11.8757 23.0947ZM16.9974 19.5812C16.1835 19.7003 15.3445 19.8566 14.5498 20.0392C14.9041 19.3523 15.2529 18.6201 15.5716 17.8914C15.7526 17.4775 15.9269 17.0581 16.0885 16.6431C16.336 17.0175 16.5942 17.3956 16.8555 17.7681C17.2581 18.3421 17.6734 18.911 18.0759 19.4437C17.7186 19.4822 17.3567 19.5287 16.9974 19.5812ZM16.0609 12.3842C16.0608 12.3829 16.0607 12.3823 16.0606 12.3823C16.0606 12.3822 16.0607 12.3838 16.061 12.3872C16.061 12.386 16.0609 12.385 16.0609 12.3842Z"
        fill="#ffffff"
      />
    </svg>
  );
};
